{
  "navigation": {
    "home": "Accueil",
    "inventory": "Inventaire",
    "recipes": "Recettes",
    "profile": "Profil",
    "back": "Retour",
    "myMeals": "Mes Repas",
    "grocery": "Épicerie",
    "pantry": "Garde-manger",
    "settings": "Paramètres"
  },
  "auth": {
    "errGeneric": "La connexion n'a pas abouti. Réessayez.",
    "login": "Se connecter",
    "register": "S'inscrire",
    "logout": "Se déconnecter",
    "signIn": "Se connecter",
    "guestMode": "Mode invité",
    "signInToSync": "Connectez-vous pour synchroniser vos données",
    "logoutConfirmation": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "email": "Courriel",
    "password": "Mot de passe",
    "loginButton": "Se connecter",
    "registerButton": "Créer un compte",
    "switchToRegister": "Pas de compte ? Inscrivez-vous",
    "switchToLogin": "Déjà un compte ? Connectez-vous",
    "tagline": "Votre assistant de planification de repas alimenté par l'IA",
    "signInWithEmail": "Se connecter par courriel",
    "backToOptions": "Retour aux options",
    "continueWithGoogle": "Continuer avec Google",
    "or": "ou",
    "continueAsGuest": "Continuer en tant qu'invité",
    "localStorageOnly": "Données stockées localement uniquement",
    "dataAgreement": "En continuant, vous acceptez que Du Chef stocke vos données alimentaires pour fournir des recommandations personnalisées.",
    "signUpToConfirm": "Inscrivez-vous pour confirmer votre plan",
    "validationEmailRequired": "Veuillez entrer votre adresse courriel.",
    "validationEmailInvalid": "Veuillez entrer une adresse courriel valide.",
    "validationPasswordRequired": "Veuillez entrer votre mot de passe.",
    "validationPasswordLength": "Le mot de passe doit contenir au moins 6 caractères.",
    "continueTitle": "Continuons.",
    "emailLabel": "Adresse email",
    "continue": "Continuer",
    "welcomeBack": "Bon retour",
    "forgotPassword": "Mot de passe oublié ?",
    "createTitle": "Créons votre compte.",
    "choosePassword": "Choisir un mot de passe",
    "createMyAccount": "Créer mon compte",
    "legalFine": "En continuant, vous acceptez nos conditions et notre confidentialité.",
    "change": "Changer",
    "successTitle": "C'est parti !",
    "successSub": "Votre cuisine synchronisée vous attend.",
    "openPaprika": "Ouvrir Du Chef",
    "brandHeadline": "Un compte, et tout suit.",
    "reason1": "Vos recettes sur tous vos appareils",
    "reason2": "Sauvegardez celles que vous aimez",
    "reason3": "Scannez votre frigo et garde-manger en photo",
    "madeIn": "Fait maison · à Montréal",
    "guestLink": "Continuer sans compte",
    "errGoogleCancelledTitle": "Connexion Google interrompue",
    "errGoogleCancelledMsg": "La fenêtre s'est fermée avant la fin. Reprenez quand vous voulez — rien n'a été perdu.",
    "retryGoogle": "Réessayer avec Google",
    "errEmailFormat": "Cette adresse ne semble pas valide — vérifiez la fin (.com, .ca…).",
    "errBadPassword": "Mot de passe incorrect. Réessayez.",
    "resetMyPassword": "Réinitialiser mon mot de passe",
    "errLockedTitle": "Trop de tentatives",
    "errLockedMsg": "Par sécurité, la connexion est suspendue quelques minutes. Réinitialisez votre mot de passe pour entrer tout de suite.",
    "resetNow": "Réinitialiser maintenant",
    "errOfflineTitle": "Connexion impossible",
    "errOfflineMsg": "Impossible de joindre Du Chef. Vérifiez votre connexion internet.",
    "retry": "Réessayer",
    "resetSentTitle": "Courriel envoyé",
    "resetSentMsg": "Si un compte existe pour cette adresse, un lien de réinitialisation vient d'être envoyé.",
    "wrongCredentials": "Courriel ou mot de passe incorrect. Veuillez réessayer.",
    "emailExists": "Un compte existe déjà avec ce courriel. Connectez-vous.",
    "tooManyAttempts": "Trop de tentatives échouées. Patientez un instant et réessayez.",
    "networkError": "Erreur réseau. Vérifiez votre connexion.",
    "resetLink": {
      "checking": "Je vérifie votre lien…",
      "title": "Un nouveau mot de passe",
      "newPassword": "Nouveau mot de passe",
      "save": "Enregistrer et me connecter",
      "invalidTitle": "Ce lien ne marche plus",
      "invalidMsg": "Un lien de réinitialisation est bon pendant une heure, et une seule fois. Demandez-en un nouveau, je vous l'envoie tout de suite.",
      "newLink": "Recevoir un nouveau lien",
      "failed": "Je n'ai pas pu enregistrer ce mot de passe. Réessayez.",
      "savedSignIn": "Votre nouveau mot de passe est enregistré. Connectez-vous avec lui.",
      "signIn": "Me connecter"
    }
  },
  "profile": {
    "accountInformation": "Informations du compte",
    "languageSettings": "Paramètres de langue",
    "editProfile": "Modifier le profil",
    "editProfileDescription": "Modification du profil bientôt disponible"
  },
  "home": {
    "title": "Du Chef",
    "welcome": "Bienvenue chez Du Chef !",
    "addFoodItem": "Ajouter nourriture",
    "scanFood": "Scanner la nourriture avec votre caméra",
    "viewInventory": "Voir l'inventaire",
    "getRecipes": "Suggestions de recettes",
    "myInventory": "Mon inventaire",
    "recipeSuggestions": "Suggestions de recettes",
    "findRecipes": "Trouvez des recettes avec vos ingrédients",
    "quickActions": "Actions rapides",
    "settings": "Paramètres",
    "appPreferences": "Préférences d'application et profil",
    "yourInventory": "Votre inventaire",
    "itemsInKitchen": "{{count}} article dans votre cuisine",
    "itemsInKitchen_other": "{{count}} articles dans votre cuisine",
    "itemsExpiringSoon": "{{count}} article expire bientôt",
    "itemsExpiringSoon_other": "{{count}} articles expirent bientôt",
    "getStarted": "Commencer",
    "getStartedText": "Commencez à construire votre inventaire alimentaire pour obtenir des suggestions de recettes personnalisées et réduire le gaspillage alimentaire",
    "startHere": "Commencez ici ! Construisez votre premier inventaire",
    "thisWeek": "Cette semaine",
    "mealsPlanned": "{{count}} repas planifié",
    "mealsPlanned_other": "{{count}} repas planifiés",
    "planYourWeek": "Planifiez votre semaine"
  },
  "inventory": {
    "title": "Mon inventaire",
    "foodInventory": "Inventaire alimentaire",
    "addItem": "Ajouter un article",
    "scanFood": "Scanner la nourriture",
    "addManually": "Ajouter manuellement",
    "editItem": "Modifier l'article",
    "deleteItem": "Supprimer l'article",
    "expiringSoon": "Expire bientôt",
    "expired": "Expiré",
    "fresh": "Frais",
    "quantity": "Quantité",
    "expiryDate": "Date d'expiration",
    "location": "Emplacement",
    "notes": "Notes",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "camera": "Caméra",
    "gallery": "Galerie",
    "noItems": "Aucun article dans votre inventaire",
    "addFirstItem": "Ajoutez votre premier article pour commencer",
    "loading": "Chargement de l'inventaire...",
    "loadingRecognition": "Analyse de l'image...",
    "recognitionResults": "Résultats de reconnaissance",
    "itemsFound": "articles trouvés",
    "addSelected": "Ajouter les articles sélectionnés",
    "addAll": "Tout ajouter",
    "clearAll": "Tout effacer",
    "totalItems": "Total d'articles",
    "categories": "Catégories",
    "lastUpdated": "Dernière mise à jour",
    "lastSynced": "Dernière synchronisation",
    "selectMultiple": "Sélection multiple",
    "itemsExpiringSoonFilter": "{{count}} article expire bientôt ! (touchez pour filtrer)",
    "itemsExpiringSoonFilter_other": "{{count}} articles expirent bientôt ! (touchez pour filtrer)",
    "expiring": "expirent",
    "qty": "Qté",
    "daysLeft": "{{count}}j restants",
    "daysAgo": "il y a {{count}}j",
    "days": "{{count}}j",
    "noExpiry": "Pas d'expiration",
    "edit": "Modifier",
    "eaten": "Consommé",
    "markAsEaten": "Marquer comme consommé",
    "markAsEatenConfirm": "Marquer \"{{name}}\" comme consommé ? Cela le retirera de votre inventaire actif.",
    "expiredDaysAgo": "Expiré il y a {{count}} jour",
    "expiredDaysAgo_other": "Expiré il y a {{count}} jours",
    "expiresToday": "Expire aujourd'hui",
    "expiresTomorrow": "Expire demain",
    "expiresInDays": "Expire dans {{count}} jour",
    "expiresInDays_other": "Expire dans {{count}} jours",
    "sync": "Sync",
    "home": "Accueil",
    "fridgePhoto": "Photo du frigo",
    "receipt": "Reçu",
    "receiptScan": "Scanner un reçu",
    "foodScanner": "Scanner de nourriture",
    "receiptScanner": "Scanner de reçu",
    "foodScannerDescription": "Prenez une photo de votre frigo, garde-manger ou ingrédients pour les identifier et les suivre automatiquement.",
    "receiptScannerDescription": "Prenez une photo de votre reçu d'épicerie pour ajouter automatiquement les articles achetés à votre inventaire.",
    "selectImage": "Sélectionner une image",
    "openCamera": "Ouvrir la caméra",
    "retake": "Reprendre",
    "analyzeFood": "Analyser la nourriture",
    "scanReceipt": "Scanner le reçu",
    "processing": "Traitement...",
    "analyzingFoodItems": "Analyse des aliments...",
    "devMode": "MODE DÉVELOPPEMENT",
    "usingTestImage": "Utilisation d'une image de test",
    "categoryFruits": "Fruits",
    "categoryVegetables": "Légumes",
    "categoryDairy": "Produits laitiers",
    "categoryMeat": "Viande",
    "categoryBeverages": "Boissons",
    "categoryCondiments": "Condiments",
    "categorySpices": "Épices",
    "categoryLeftovers": "Restes",
    "categoryPackagedFoods": "Aliments emballés",
    "categoryBreadGrains": "Pain/Céréales",
    "categoryPlantBasedProtein": "Protéines végétales",
    "categoryOther": "Autre",
    "itemNameLabel": "Nom de l'article",
    "itemNamePlaceholder": "ex. Lait, Bananes, Pâtes restantes...",
    "optional": "Facultatif",
    "expiryHint": "Laissez vide si vous ne connaissez pas la date d'expiration",
    "dayLabel": "Jour",
    "monthLabel": "Mois",
    "yearLabel": "Année",
    "expiryNoteLabel": "Note d'expiration",
    "expiryNotePlaceholder": "ex. À consommer de préférence avant, Date limite...",
    "editLaterHint": "Vous pouvez toujours modifier ces détails plus tard en touchant l'article dans votre inventaire.",
    "addToInventory": "Ajouter à l'inventaire",
    "errorInvalidName": "Veuillez entrer un nom d'article",
    "errorInvalidDay": "Veuillez entrer un jour valide (1-31)",
    "errorInvalidMonth": "Veuillez entrer un mois valide (1-12)",
    "errorInvalidYear": "Veuillez entrer une année valide (2024-2030)",
    "errorInvalidDate": "Veuillez entrer une date valide",
    "manualExpiryExplanation": "Date d'expiration saisie manuellement",
    "categoryLabel": "Catégorie",
    "scanCarousel1": "Identification de chaque ingrédient dans votre frigo...",
    "scanCarousel2": "Suivi des dates d'expiration pour éviter le gaspillage.",
    "scanCarousel3": "Construction de votre garde-manger numérique.",
    "scanCarousel4": "Association de vos ingrédients à des recettes personnalisées.",
    "scanCarousel5": "Planification de repas selon vos vrais ingrédients.",
    "scanCarousel6": "Économisez en utilisant ce que vous avez déjà.",
    "scanCarousel7": "Une photo. Une semaine de repas. Zéro gaspillage.",
    "confirmDateTitle": "Confirmer la date d'achat",
    "confirmDateMessage": "Nous n'avons pas pu lire la date sur ce reçu. Confirmez la date de vos achats avant d'enregistrer.",
    "failedToAnalyze": "Impossible d'analyser l'image",
    "quotaExceeded": "Vous avez utilisé votre quota d'analyses pour aujourd'hui. Il se renouvelle demain — vous pouvez ajouter vos articles à la main entre-temps.",
    "confirmDatePrompt": "Nous n'avons pas pu lire la date du reçu. Quand avez-vous fait vos achats ?",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "invalidDateTitle": "Date invalide",
    "invalidDateMessage": "Veuillez entrer une date valide (AAAA-MM-JJ) qui n'est pas dans le futur.",
    "dateConfirmed": "Date confirmée",
    "confirmDateButton": "Confirmer la date",
    "detectedItem": "ARTICLE DÉTECTÉ",
    "match": "CORRESPONDANCE",
    "ignore": "IGNORER",
    "confirm": "CONFIRMER",
    "confirmItems": "Confirmer les articles",
    "tapMarkers": "Touchez les marqueurs pour vérifier",
    "placingMarkers": "Placement des marqueurs…",
    "howMuch": "Quelle quantité avez-vous ?",
    "takePictureFailed": "Impossible de prendre la photo. Veuillez réessayer.",
    "parseFailed": "Impossible d'analyser les résultats",
    "incompleteScanWarning": "Nous n'avons pas pu lire {{failed}} des {{total}} sections de ce reçu — certains articles pourraient manquer. Ajoutez-les à la main après l'enregistrement."
  },
  "recipes": {
    "title": "Recettes",
    "searchPlaceholder": "Rechercher des recettes...",
    "omnibar": {
      "placeholder": "Rechercher ou demander au Chef",
      "placeholderFocused": "Rechercher…"
    },
    "shelves": {
      "recentlyAdded": "Ajoutées récemment",
      "recentlyViewed": "Consultées récemment",
      "topRated": "Vos mieux notées",
      "communityTop": "Top des autres cuisinés",
      "pantry": "Votre garde-manger",
      "seeAll": "Tout voir",
      "pantryCount": "{{count}} dispo"
    },
    "ideaOfDay": {
      "title": "L'idée du jour",
      "angles": {
        "fast": "Plus rapide",
        "fridge": "Utilise votre frigo",
        "new": "Jamais essayé",
        "fav": "Valeur sûre"
      }
    },
    "filters": {
      "button": "Filtres",
      "title": "Filtres",
      "reset": "Réinitialiser",
      "apply": "Voir {{count}} recettes",
      "diet": {
        "label": "Régime",
        "all": "Tous",
        "veg": "Végé",
        "fish": "Poisson",
        "meat": "Viande"
      },
      "duration": {
        "15": "< 15 min",
        "30": "< 30 min",
        "45": "< 45 min",
        "60": "< 1 h",
        "label": "Durée",
        "all": "Tous"
      },
      "rating": {
        "label": "Note",
        "all": "Toutes",
        "4.5": "★ 4,5 et +",
        "4.8": "★ 4,8 et +",
        "5.0": "5 ★ seulement"
      },
      "mealType": {
        "label": "Type de repas",
        "breakfast": "Déjeuner",
        "lunch": "Dîner",
        "dinner": "Souper",
        "dessert": "Dessert"
      },
      "preference": {
        "diet": "{{diet}} · votre préférence"
      }
    },
    "search": {
      "cancel": "Annuler",
      "resultsCount": "{{count}} recette · « {{query}} »",
      "resultsCount_other": "{{count}} recettes · « {{query}} »",
      "rows": {
        "yours": "Vos recettes",
        "rest": "Les autres recettes",
        "backToAll": "Tous les résultats",
        "addedOn": "Ajoutée le {{date}}"
      }
    },
    "aiEscalation": {
      "title": "Demander au Chef",
      "suggestion": "Que faire avec {{query}} ce soir ?"
    },
    "noRecipes": "Aucune recette trouvée",
    "loadingSuggestions": "Recherche de recettes pour vous...",
    "findingPerfectRecipes": "Recherche de recettes sur les meilleures sites, parfaites selon vos ingrédients.",
    "searchingTrustedSources": "Recherche dans des sources fiables :",
    "basedOnInventory": "Basé sur votre {{count}} article d'inventaire",
    "basedOnInventory_other": "Basé sur vos {{count}} articles d'inventaire",
    "customizeRecipeSearch": "Personnaliser la recherche de recettes",
    "selectedExpiring": "{{selected}} sélectionné • {{expiring}} expirent",
    "searchInventory": "Rechercher dans l'inventaire...",
    "selectAll": "Tout sélectionner",
    "clearAll": "Tout effacer",
    "selectedCount": "Sélectionné ({{count}}) :",
    "proteins": "PROTÉINES",
    "vegetables": "LÉGUMES",
    "otherIngredients": "AUTRES INGRÉDIENTS",
    "noIngredientsFound": "Aucun ingrédient trouvé",
    "tryDifferentSearch": "Essayez un autre terme de recherche",
    "minimumSelectionRequired": "Sélection minimale requise",
    "minimumSelectionMessage": "Veuillez sélectionner au moins 2 ingrédients pour rechercher des recettes.",
    "expShort": "Exp.",
    "cancel": "Annuler",
    "applyCount": "Appliquer ({{count}})",
    "expInvalidDate": "Exp. Date invalide",
    "matchScore": "Score de correspondance",
    "servings": "portions",
    "readyIn": "Prêt en",
    "healthScore": "Score santé",
    "ingredients": "Ingrédients",
    "instructions": "Instructions",
    "missing": "Manquant",
    "expiringSoon": "Utilise {{count}} article qui expire",
    "expiringSoon_other": "Utilise {{count}} articles qui expirent",
    "originalLanguage": "Langue originale",
    "translateTo": "Traduire en {{language}}",
    "translating": "Traduction en cours...",
    "translatedFrom": "Traduit de {{language}}",
    "personalRecipe": "Recette personnelle",
    "recipeNotFound": "Recette non trouvée",
    "loadingRecipe": "Chargement de la recette...",
    "goHome": "Accueil",
    "home": "Accueil",
    "tabs": {
      "browse": "Parcourir",
      "askAI": "Demander au Chef"
    },
    "aiPlaceholder": "Cherchez une recette ou collez-en une pour l'ajouter...",
    "aiSearching": "Recherche en cours...",
    "aiNoResults": "Aucune recette correspondante trouvée. Essayez de reformuler votre demande.",
    "aiError": "Une erreur est survenue. Veuillez réessayer.",
    "aiSignInRequired": "Connectez-vous pour utiliser Demander au Chef.",
    "chatEmptyHeadline": "De quoi avez-vous envie ?",
    "chatEmptySubtext": "Cherchez vos recettes ou collez-en une pour l'ajouter à votre collection.",
    "chatInputPlaceholder": "Posez une question sur n'importe quelle recette…",
    "addFirstRecipe": "Ajoutez votre première recette pour commencer",
    "importDescription": "Importez depuis un site web ou ajoutez manuellement",
    "addRecipe": "Ajouter une recette",
    "loadingRecipes": "Chargement des recettes...",
    "trySearching": "Essayez une autre recherche ou un autre filtre",
    "filteredCount": "{{filtered}} sur {{total}}",
    "shortcuts": {
      "quick": "≤ 20 min",
      "quick30": "≤ 30 min",
      "quick45": "≤ 45 min",
      "pantry": "Mon frigo",
      "topRated": "4,5 et +",
      "surprise": "Surprenez-moi",
      "surpriseShort": "Surprise",
      "vegetarian": "Végétarien",
      "fish": "Poisson",
      "without": "Sans {{word}}"
    },
    "libraryCount_one": "{{count}} recette",
    "libraryCount_other": "{{count}} recettes",
    "cookingFor": "Pour {{count}} personnes",
    "cookingFor_one": "Pour {{count}} personne",
    "cookTime": "de cuisson",
    "ask": "Demander",
    "cook": "Cuisiner",
    "signInToSave": "Connectez-vous pour enregistrer des recettes",
    "recipeDetected": "Recette détectée ! Vérifiez ci-dessous.",
    "saveRecipe": "Enregistrer la recette",
    "ingredientsCount": "{{count}} ingrédients",
    "stepsCount": "{{count}} étapes",
    "parsingRecipe": "Analyse du texte de la recette...",
    "incompleteRecipeError": "Cette recette n'a pas d'ingrédients ou d'étapes — ajoutez-les avant d'enregistrer",
    "mealTypes": {
      "recent": "Récents",
      "all": "Tous",
      "myTopRated": "Mes Mieux Notés",
      "topOnline": "Mieux Notés en Ligne",
      "breakfast": "Déjeuner",
      "mainCourse": "Plat principal",
      "dessert": "Dessert",
      "snack": "Collation",
      "appetizer": "Entrée",
      "sideDish": "Accompagnement",
      "salad": "Salade",
      "soup": "Soupe",
      "beverage": "Boisson"
    },
    "myTopRatedBanner": "Ces évaluations sont les vôtres — pas celles du site de la recette. Notez une recette pour commencer votre liste.",
    "myTopRatedEmpty": "Notez des recettes pour les voir ici",
    "myTopRatedExplore": "Explorer les recettes",
    "nearMissBanner": "Aucun résultat exact — voici ce qui s'en rapproche",
    "nearMissEyebrow": "SIMILAIRES",
    "resultsCount_one": "{{count}} RECETTE",
    "resultsCount_other": "{{count}} RECETTES",
    "exactSearchEyebrow": "RECHERCHE EXACTE",
    "noResultsAtAll": "Aucune recette ne correspond à cette recherche",
    "activeFilters": "FILTRES ACTIFS",
    "understoodLine": "Du Chef a compris — retirez un jeton ou précisez ci-dessus",
    "exactSearchLink": "Recherche exacte",
    "searchIdleHint": "Cherchez une recette, un ingrédient ou un type de cuisine — ou posez une question au Chef.",
    "stepsCount_one": "{{count}} étape"
  },
  "fanReasons": {
    "fastSaves": "{{count}} min de moins qu'actuellement",
    "fastSaves_other": "{{count}} min de moins qu'actuellement",
    "fastOnly": "Seulement {{count}} min",
    "fastOnly_other": "Seulement {{count}} min",
    "fastGeneric": "Un classique express",
    "fridgeHits": "{{count}} ingrédient déjà chez vous",
    "fridgeHits_other": "{{count}} ingrédients déjà chez vous",
    "fridgeGeneric": "Change des idées habituelles",
    "balance": "Rééquilibre la semaine",
    "new": "Absent de votre historique",
    "favRating": "{{rating}} ★",
    "favGeneric": "Votre meilleur match",
    "fast": "Plus rapide",
    "fastMore": "Encore plus rapide",
    "fridge": "Utilise votre frigo",
    "fav": "Valeur sûre",
    "balanceLabel": "Équilibre la semaine",
    "newLabel": "Jamais essayé",
    "balanceFish": "Rééquilibre : +1 poisson cette semaine",
    "balanceVeg": "Rééquilibre : +1 végé cette semaine",
    "balanceMeat": "Rééquilibre : +1 viande cette semaine"
  },
  "fanChips": {
    "more_one": "{{count}} nouvelle",
    "more_other": "{{count}} nouvelles",
    "moreLabel_one": "Proposer {{count}} nouvelle idée",
    "moreLabel_other": "Proposer {{count}} nouvelles idées",
    "restart": "Recommencer",
    "sweet": "Sucré",
    "savory": "Salé",
    "soup": "Soupe",
    "salad": "Salade",
    "sandwich": "Sandwich",
    "pasta": "Pâtes",
    "fish": "Poisson",
    "veg": "Végé",
    "quick": "Rapides",
    "fridge": "Mon frigo",
    "favorites": "Mes favoris",
    "loved": "Vous l'avez adorée"
  },
  "sideFoods": {
    "label": "Avec ce que vous avez",
    "rows": "×{{count}}",
    "with": "Avec {{foods}}",
    "withAlso": "Avec {{foods}} · aussi {{also}}",
    "noneTogether": "Je n'ai aucun accompagnement avec {{foods}} à la fois. Voici ceux qui en prennent une partie."
  },
  "sideReasons": {
    "togetherLabel": "Prêt en même temps",
    "fridgeFoods": "Utilise ce que vous avez : {{foods}}",
    "together": "{{count}} min, pendant que le plat cuit",
    "together_other": "{{count}} min, pendant que le plat cuit",
    "balanceLabel": "Pour compléter l'assiette",
    "fresh": "Du frais à côté",
    "vegetable": "Un légume à côté",
    "starch": "De quoi caler la tablée"
  },
  "recipeSuggestions": {
    "searchSummary": {
      "title": "Aperçu de recherche",
      "expiring": "expirent",
      "ingredientsLabel": "Ingrédients sélectionnés",
      "sourcesLabel": "Sources consultées",
      "queriesCount": "{{count}} requête de recherche générée",
      "queriesCount_other": "{{count}} requêtes de recherche générées",
      "tapHint": "Touchez pour sélectionner/désélectionner",
      "tapHintSources": "Touchez pour inclure/exclure",
      "searchWithIngredients": "Recherche ({{count}} ingrédient)",
      "searchWithIngredients_other": "Recherche ({{count}} ingrédients)",
      "expiringCount": "{{count}} expirent"
    },
    "title": "Suggestions de recettes",
    "moved": "Cette fonction passe au menu de la semaine."
  },
  "thisWeek": {
    "title": "Cette semaine",
    "yourWeek": "Votre semaine",
    "noMealsPlanned": "Aucun repas planifié",
    "startPlanning": "Commencez à planifier votre semaine en touchant l'icône calendrier sur les cartes de recettes",
    "browseRecipes": "Parcourir les recettes",
    "addMoreMeals": "Ajouter d'autres repas",
    "fridgeStocked": "Votre frigo est bien garni !",
    "itemsAddedSuffix": "items ajoutés à votre garde-manger. Générez des repas avec ce que vous avez.",
    "generateFromInventory": "Générez des repas avec ce que vous avez.",
    "generateMeals": "Générer les repas de la semaine",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "yesterday": "Hier",
    "recipeNotAvailable": "Recette non disponible",
    "recipeNotAvailableText": "Les détails de la recette ne sont pas disponibles pour ce repas.",
    "unknownRecipe": "Recette inconnue",
    "swappingRecipe": "Remplacement de la recette...",
    "shoppingNeeded": "Achats nécessaires",
    "readyToCook": "Prêt à cuisiner",
    "reviewIngredients": "Vérifier les ingrédients",
    "mealTypes": {
      "breakfast": "Déjeuner",
      "lunch": "Dîner",
      "dinner": "Souper"
    },
    "dayNames": {
      "sunday": "Dimanche",
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi"
    },
    "dayShort": {
      "sun": "Dim",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam"
    },
    "noMealsPlannedShort": "Aucun repas planifié",
    "weekOf": "Semaine du {{range}}",
    "previousWeek": "Semaine précédente",
    "nextWeek": "Semaine suivante",
    "addMealType": "AJOUTER {{mealType}}",
    "add": "Ajouter",
    "openRow": "Agrandir : {{meal}}",
    "weeklyMenu": "Menu de la semaine",
    "tasteProfile": "Votre profil de goût",
    "seasons": {
      "winter": "Hiver",
      "spring": "Printemps",
      "summer": "Été",
      "fall": "Automne"
    },
    "progress": {
      "cooked": "{{cooked}} sur {{total}} cuisinés",
      "skipped": "{{skipped}} sauté",
      "toCome": "{{upcoming}} à venir"
    },
    "mealTags": {
      "meat": "Viande",
      "fish": "Poisson",
      "veggie": "Végé",
      "plantBased": "À base de plantes",
      "notCooked": "Non cuisiné"
    },
    "stats": {
      "meals": "{{count}} repas",
      "fish": "{{count}} poisson",
      "veggie": "{{count}} végé"
    },
    "heroTitle": "Vos soupers de la semaine, planifiée en quelques secondes, meilleures à chaque fois.",
    "heroSubtitle": "On suggère des soupers parmi vos recettes. Photographiez votre frigo pour personnaliser le plan.",
    "generateMyWeek": "Générer ma semaine",
    "creatingYourPlan": "Création de votre plan...",
    "planningYourWeek": "On planifie votre semaine...",
    "orAddManually": "ou ajouter des repas manuellement",
    "startFresh": "Recommencer",
    "regenerateThisWeek": "Re-générer cette semaine",
    "clearPlanTitle": "Effacer le plan",
    "clearPlanMessage": "Êtes-vous sûr de vouloir effacer tous les repas planifiés pour cette semaine ?",
    "clearPlanConfirm": "Effacer",
    "chooseARecipe": "Choisir une recette",
    "addSlots": "Ajouter {{count}} créneaux",
    "noMealsForDay": "Aucun repas planifié pour cette journée",
    "dinnerAt": "Souper à",
    "markAsDone": "Marquer comme fait",
    "undo": "Annuler",
    "rateThis": "Noter",
    "enjoyed": "Dégusté !",
    "timingNotAvailable": "Horaire non disponible",
    "minTotal": "{{count}} min au total",
    "prepAndCook": "({{prep}} préparation + {{cook}} cuisson)",
    "untitledMeal": "Repas sans titre",
    "showFullWeek": "Voir la semaine",
    "compactView": "Vue compacte",
    "moveMealTitle": "Déplacer le repas",
    "selectDay": "Jour",
    "selectMealType": "Repas",
    "slotFull": "complet",
    "suggestAction": "Suggérer",
    "moveAction": "Déplacer",
    "deleteAction": "Supprimer",
    "idleTitle": "Planifions votre semaine",
    "idleBody": "Soupers pour 7 soirs · déjeuners le week-end. Optimisé pour votre garde-manger.",
    "desktopIdleBody": "Du Chef sélectionne 7 dîners en tenant compte de votre frigo, de vos goûts et de l’équilibre de la semaine.",
    "idleFootnote": "Vous pourrez ajuster chaque repas après la génération.",
    "idleFootnoteMobile": "Vous pourrez tout changer ensuite.",
    "analyzingTaste": "Analyse de vos goûts…",
    "weekView": "Semaine",
    "detailView": "Détail",
    "regenerate": "Régénérer",
    "regeneratePastOnly": "Ces jours sont passés, je n'y touche pas",
    "regenerateTodayKept": "Je garde le repas d'aujourd'hui. Ouvrez-le pour le changer.",
    "regenerateRange": "Régénère : {{from}} → {{to}}",
    "regenerateRangeShort": "{{from}} → {{to}}",
    "noRecipeForMeal": "Aucune recette de {{meal}}",
    "toastReplaced": "Remplacé : {{title}}",
    "toastReplacedBy": "Remplacé par « {{title}} »",
    "toastAdded": "Ajouté : {{title}}",
    "toastAddedSimple": "« {{title}} » ajouté",
    "toastMoved": "{{title}} déplacé",
    "toastSwapped": "{{title}} déplacé · échangé avec {{other}}",
    "toastRemoved": "{{title}} retiré",
    "meal": "Repas",
    "fanSheetTitle": "5 idées pour ce repas",
    "currentMealPrefix": "actuellement",
    "viewRecipe": "Voir la recette",
    "moveToDay": "Déplacer vers un jour",
    "remove": "Retirer",
    "orReplaceWith": "Ou remplacer par",
    "noAlternatives": "Aucune alternative pour ce repas.",
    "browseLibrary": "Parcourir toute la bibliothèque",
    "moveTo": "Déplacer vers…",
    "fromDay": "depuis {{day}}",
    "emptySlot": "Vide",
    "noTimeLimit": "libre",
    "swap": "Échanger",
    "place": "Placer",
    "regenerateWeek": "Regénérer la semaine",
    "dayProfiles": {
      "0": {
        "tag": "Sans les enfants",
        "note": "place aux saveurs qu’ils n’aiment pas"
      },
      "1": {
        "tag": "Sans les enfants",
        "note": "épices et nouveautés bienvenues"
      },
      "2": {
        "tag": "Soir enfants",
        "note": "rapide, simple, validé par les petits"
      },
      "3": {
        "tag": "Semaine",
        "note": "léger et sous les 30 min"
      },
      "4": {
        "tag": "Vous avez le temps",
        "note": "on peut viser plus ambitieux ce soir"
      },
      "5": {
        "tag": "Week-end",
        "note": "plat plaisir, on cuisine pour de vrai"
      },
      "6": {
        "tag": "Batch cooking",
        "note": "idéal pour cuisiner en avance"
      }
    },
    "desktopHint": "Cliquez une recette pour la consulter · glissez-la vers un autre jour",
    "desktopHintTouch": "Touchez une recette pour la consulter · touchez « Déplacer » pour la changer de jour",
    "editSettings": "Modifier mes réglages",
    "library": "Bibliothèque",
    "thisMeal": "Ce repas",
    "movedTo": "{{recipe}} déplacé au {{day}}",
    "swappedWith": "{{recipe}} ↔ {{day}} · échangé",
    "leftoverFrom": "Du {{day}} ({{meal}})",
    "move": "Déplacer",
    "dayWithDate": "{{day}} {{date}}",
    "addHere": "Ajouter",
    "replace": "Remplacer",
    "replacedOn": "{{recipe}} a remplacé {{other}} · {{day}}",
    "stackedInto": "{{recipe}} ajouté au {{day}}",
    "summary": {
      "recipes_one": "recette",
      "recipes_other": "recettes",
      "dining_one": "au resto",
      "dining_other": "au resto",
      "notes_one": "repas simple",
      "notes_other": "repas simples",
      "skipped_one": "sans repas",
      "skipped_other": "sans repas"
    },
    "addDish": "Ajouter un plat",
    "addDishTitle": "Ajouter un plat à ce repas",
    "orAddDish": "Ou ajouter un plat",
    "addSide": "avec ça",
    "addSideLong": "Ajouter un accompagnement",
    "goesWith": "Pour aller avec",
    "addToThisMeal": "Ajouter à ce repas",
    "withSide": "avec",
    "moreSides": "Autres",
    "moreSidesLong": "Autres accompagnements",
    "sidesOther": "Autre chose : pain, dessert, un 2ᵉ plat…",
    "sidesEmpty": "Rien à vous proposer pour aller avec ce plat. Cherchez dans vos recettes.",
    "removeSide": "Retirer {{title}}",
    "dishCount_one": "{{count}} plat",
    "dishCount_other": "{{count}} plats",
    "cooked": "Cuisiné",
    "cookNow": "Cuisiner",
    "cookedCount": "{{cooked}}/{{total}} cuisinés",
    "minutesShort": "{{count}} min",
    "servingsShort_one": "{{count}} portion",
    "servingsShort_other": "{{count}} portions",
    "viewFullRecipe": "Voir la recette complète",
    "rateThisRecipe": "Donnez votre avis sur cette recette",
    "unmarkCooked": "Retirer « cuisiné »",
    "totalLabel": "Total",
    "portionsLabel": "Portions",
    "noRecipeThatDay": "Sans recette",
    "picker": {
      "context": "{{meal}} · {{weekday}} {{date}}",
      "placeOn": "Mettre {{day}}",
      "withIngredients": "Avec vos ingrédients",
      "results": "Résultats",
      "recipeCount_one": "{{count}} recette",
      "recipeCount_other": "{{count}} recettes"
    },
    "wholeLibrary": "Toute la bibliothèque",
    "resetToWeekDefault": "Revenir au défaut de la semaine ({{count}})",
    "noRecipeShort": "Pas de recette ?",
    "clearSlot": "Vider la case",
    "planAMeal": "Planifier ce repas",
    "selectTimeSlot": "Choisir un moment",
    "browseAllRecipes": "Parcourir toutes les recettes",
    "addCustomMeal": "Ajouter un repas personnalisé",
    "showAllSuggestions": "Voir toutes les suggestions",
    "orTypeYourOwn": "ou écrivez le vôtre",
    "allIngredientsCovered": "Tous les ingrédients sont couverts",
    "youHaveEverything": "Vous avez tout !",
    "whyThisRecipe": "Pourquoi cette recette",
    "notCooked": "Pas cuisiné",
    "noAlternativesFound": "Aucune alternative trouvée",
    "noRecipesForFilter": "Aucune recette pour ce filtre.",
    "dropHere": "Déposer ici",
    "noRecipesAvailable": "Aucune recette disponible. Importez d'abord des recettes.",
    "generateFailed": "Impossible de générer le menu. Veuillez réessayer.",
    "noAlternativeTryBrowse": "Aucune recette de remplacement — essayez Parcourir",
    "noNewIdea": "Impossible de trouver une nouvelle idée. Veuillez réessayer.",
    "slotFullMax": "Ce repas est complet (max {{max}})",
    "quickRestaurant": "Resto",
    "quickLeftovers": "Restes",
    "quickTakeout": "À emporter",
    "quickSkip": "Sauter",
    "customMealPlaceholder": "Ex. « Soirée pâtes », « BBQ chez Mike »",
    "leftoverFromFreezer": "Du congélateur",
    "leftoverReheat": "Réchauffer",
    "leftoverThaw": "Sortir la veille",
    "leftoverNoneTitle": "Aucun repas cuisiné récemment",
    "leftoverNoneBody": "Les restes apparaissent ici une fois un repas marqué cuisiné.",
    "leftoverFridgeSection": "Au frigo · {{days}} jours",
    "leftoverFreezerSection": "Au congélateur",
    "leftoverPortionsLeft_one": "{{count}} portion",
    "leftoverPortionsLeft_other": "{{count}} portions",
    "leftoverExhausted": "épuisé",
    "leftoverExpiresOn": "Expire le {{date}}",
    "leftoverFrozenOn": "Congelé le {{date}}",
    "leftoverPickerSubtitle": "{{day}} · d'un repas récent",
    "leftoverBannerTitle_one": "{{count}} portion de restes à placer",
    "leftoverBannerTitle_other": "{{count}} portions de restes à placer",
    "leftoverBannerSub": "{{recipe}} · à manger avant {{date}}",
    "leftoverSlotHint": "Restes — {{recipe}}",
    "leftoverSlotHintSub_one": "{{count}} dispo · appuyer pour placer",
    "leftoverSlotHintSub_other": "{{count}} dispo · appuyer pour placer",
    "leftoverAskTitle": "Des restes du {{recipe}} ?",
    "leftoverAskSub": "Cuisiné {{day}} · {{servings}} portions prévues",
    "leftoverAskFridge": "Au frigo",
    "leftoverAskFridgeSub": "{{days}} jours",
    "leftoverAskFreezer": "Au congélateur",
    "leftoverAskFreezerSub": "{{days}} jours · va au garde-manger",
    "leftoverAskNone": "Non, aucun reste",
    "leftoverAskSave": "Enregistrer",
    "leftoverFrozenName": "Restes — {{recipe}}",
    "previousWeeks": "Semaines précédentes",
    "backToThisWeek": "Revenir à cette semaine",
    "weekOfDivider": "Semaine du {{date}}",
    "scrollEnd": "Douze semaines devant, c'est la limite : vous voyez tout jusqu'au {{date}}",
    "addOtherMeal": "Ajouter un repas ou un plat",
    "hideOtherMeals": "Replier",
    "extend": {
      "title": "Planifier les 7 jours suivants",
      "busy": "Je prépare vos soupers…",
      "range": "{{from}} → {{to}}",
      "added_one": "{{count}} souper ajouté",
      "added_other": "{{count}} soupers ajoutés",
      "nothing": "Rien à ajouter : ces soirs sont déjà prévus",
      "pendingDay": "Je choisis votre souper de {{day}}"
    },
    "groceryAsk": {
      "title_one": "Ajouter ce souper à votre liste d'épicerie ?",
      "title_other": "Ajouter ces {{count}} soupers à votre liste d'épicerie ?",
      "add": "Ajouter",
      "later": "Plus tard",
      "done": "Liste d'épicerie mise à jour"
    },
    "fanTitle": "{{count}} idée pour ce repas",
    "fanTitle_other": "{{count}} idées pour ce repas",
    "orChooseRecipe": "Ou choisir une recette",
    "fanEmpty": "Pas d'autres recettes dans votre bibliothèque. Ajoutez-en pour recevoir des idées.",
    "dayProfile": {
      "mon": {
        "tag": "Rapide",
        "note": "Soirée chargée"
      },
      "tue": {
        "tag": "Léger",
        "note": "Milieu de semaine"
      },
      "wed": {
        "tag": "Varié",
        "note": "On change un peu"
      },
      "thu": {
        "tag": "Confort",
        "note": "Jeudi soir"
      },
      "fri": {
        "tag": "Festif",
        "note": "Début de weekend"
      },
      "sat": {
        "tag": "Brunch",
        "note": "Weekend"
      },
      "sun": {
        "tag": "Doux",
        "note": "Dimanche"
      }
    },
    "toastNothingPlanned": "Rien de prévu ce jour-là",
    "toastSlotCleared": "Case vidée",
    "slotTitle": "{{meal}} du {{day}}",
    "swapSuggestion": "Suggestion de remplacement",
    "suggestedFor": "Suggestions pour",
    "filteredFor": "{{filter}} pour",
    "suggestionFilters": {
      "quick": "Rapide",
      "veggie": "Végétarien",
      "fish": "Poisson et fruits de mer",
      "favorite": "Favoris",
      "new": "Nouvelles recettes",
      "cuisine": "Cuisine"
    },
    "findingRecipes": "Recherche de recettes…",
    "noSuggestions": "Aucune recette trouvée",
    "noFilteredSuggestions": "Aucune recette trouvée pour « {{filter}} »",
    "seeMoreSuggestions_one": "Voir {{count}} autre suggestion",
    "seeMoreSuggestions_other": "Voir {{count}} autres suggestions",
    "suggestionBadges": {
      "veggie": "Pour varier",
      "fish": "Poisson",
      "favorite": "Favori",
      "new": "À essayer"
    },
    "inProgress": "En cours →",
    "toBuyCount": "{{count}} à acheter",
    "youHaveOf": "Vous avez {{have}}/{{total}} ingrédients",
    "needToBuyCount": "À acheter ({{count}}) :",
    "markCooked": "Marquer comme cuisiné",
    "suggestionFallback": "Votre bibliothèque — aucune recette ne correspond exactement à ce repas",
    "planDay": "Planifier",
    "proteinFish": "Poisson",
    "proteinPlantBased": "Végétal",
    "toastPlacedIn": "Ajouté au {{meal}} de {{dayLower}} : {{title}}",
    "changeMeal": "Changer",
    "addToDay": "Ajouter",
    "addToDayLabel": "Ajouter un repas : {{day}}",
    "mealSlotState": {
      "free": "libre",
      "full": "prévu",
      "past": "passé"
    },
    "backToToday": "Aujourd'hui",
    "markedDone": "Bon appétit ! J'ai noté que vous avez cuisiné {{name}}."
  },
  "mealCard": {
    "fromInventory": "de l'inventaire",
    "usesExpiringItems": "Utilise des articles qui expirent"
  },
  "groceryList": {
    "title": "Liste d'épicerie",
    "generateList": "Générer la liste d'épicerie",
    "viewList": "Voir la liste d'épicerie",
    "clearList": "Effacer la liste",
    "addItem": "Ajouter un article",
    "addCustomItem": "Ajouter un article personnalisé",
    "itemName": "Nom de l'article",
    "category": "Catégorie",
    "cancel": "Annuler",
    "add": "Ajouter",
    "noItemsYet": "Aucun article",
    "noItemsText": "Votre liste d'épicerie se met à jour automatiquement selon votre plan de repas. Vous pouvez aussi ajouter des articles manuellement.",
    "addFirstItem": "Ajouter un article",
    "wasteReduction": "Réduction du gaspillage",
    "alreadyHave": "Déjà en stock",
    "ingredients": "Ingrédients",
    "estSavings": "Économies est.",
    "expiring": "Expire",
    "itemsRemaining": "{{count}} article restant",
    "itemsRemaining_other": "{{count}} articles restants",
    "percentInKitchen": "{{percent}}% des ingrédients déjà dans votre cuisine",
    "clearConfirm": "Êtes-vous sûr de vouloir effacer toute la liste d'épicerie?",
    "custom": "Personnalisé",
    "itemNamePlaceholder": "ex. Huile d'olive extra vierge",
    "addItemButton": "Ajouter l'article",
    "addCustomItemTitle": "Ajouter un article personnalisé",
    "categories": {
      "produce": "Fruits et légumes",
      "dairy": "Produits laitiers",
      "meat": "Viande",
      "bakery": "Boulangerie",
      "pantry": "Garde-manger",
      "spices": "Épices",
      "frozen": "Surgelés",
      "beverages": "Boissons",
      "other": "Autre"
    },
    "addAnItem": "Ajouter un article",
    "basedOnServings": "Basé sur {{count}} portions par repas",
    "byRecipe": "Par recette",
    "byCategory": "Par rayon",
    "otherItems": "Autres articles",
    "clear": "Effacer",
    "clearListTitle": "Effacer la liste",
    "clearListMessage": "Effacer les {{count}} articles ?",
    "clearAll": "Tout effacer",
    "noItemsToCopy": "Rien à copier. Tous les articles sont cochés !",
    "copiedToClipboard": "{{count}} ingrédients copiés dans le presse-papier",
    "updating": "Mise à jour de votre liste...",
    "listOutOfDate": "La liste n'est peut-être plus à jour",
    "addFromRecipes": "Votre liste d'épicerie se met à jour automatiquement selon votre plan de repas. Vous pouvez aussi ajouter des articles manuellement.",
    "noLufaMatchesTitle": "Aucune correspondance Lufa",
    "noLufaMatchesText": "Aucun de vos articles d'épicerie ne correspond aux offres Lufa Farms cette semaine.",
    "availableAtLufa": "Disponible chez Lufa Farms",
    "shopAll": "Tout voir",
    "forRecipes": "Pour : {{recipes}}",
    "quickAddPlaceholder": "Ajout rapide...",
    "quickAddButton": "Ajouter",
    "inYourInventory": "Dans votre inventaire",
    "confirmedByYou": "Confirmé par vous",
    "kitchenStaples": "Essentiels de cuisine",
    "inStock": "{{count}} en stock",
    "inStockNeed": "{{count}} en stock (besoin de {{needed}})",
    "autoBannerLead": "Construite depuis votre plan.",
    "autoBannerLeadFromToday": "Construite depuis votre plan, d'aujourd'hui à {{end}}.",
    "autoBannerLeadTodayOnly": "Construite depuis votre plan, pour aujourd'hui seulement.",
    "autoBannerRemovedOne": "On a retiré {{part}}.",
    "autoBannerRemovedBoth": "On a retiré {{pantry}} et {{staples}}.",
    "autoBannerPantryPart": "{{count}} article de votre garde-manger",
    "autoBannerPantryPart_other": "{{count}} articles de votre garde-manger",
    "autoBannerStaplePart": "{{count}} essentiel de cuisine ({{examples}})",
    "autoBannerStaplePart_other": "{{count}} essentiels de cuisine ({{examples}})",
    "staples": {
      "salt": "Sel",
      "pepper": "Poivre",
      "oil": "Huile",
      "olive-oil": "Huile d'olive",
      "vegetable-oil": "Huile végétale",
      "flour": "Farine",
      "cornstarch": "Fécule de maïs",
      "sugar": "Sucre",
      "brown-sugar": "Cassonade",
      "baking-soda": "Bicarbonate de soude",
      "vanilla-extract": "Extrait de vanille",
      "oregano": "Origan",
      "thyme": "Thym",
      "basil": "Basilic séché",
      "parsley": "Persil séché",
      "cumin": "Cumin",
      "coriander": "Coriandre moulue",
      "paprika": "Paprika",
      "cinnamon": "Cannelle",
      "nutmeg": "Muscade",
      "cayenne": "Poivre de Cayenne",
      "garam-masala": "Garam masala",
      "turmeric": "Curcuma",
      "bay-leaf": "Feuille de laurier",
      "red-pepper-flakes": "Flocons de piment",
      "herbes-de-provence": "Herbes de Provence",
      "italian-seasoning": "Assaisonnement italien",
      "markMissing": "Je ne l'ai pas",
      "excludedToast": "{{name}} ajouté à la liste"
    },
    "autoSealNow": "Auto · à l'instant",
    "autoSealMin": "Auto · il y a {{count}} min",
    "autoSealMin_other": "Auto · il y a {{count}} min",
    "autoSealHours": "Auto · il y a {{count}} h",
    "autoSealHours_other": "Auto · il y a {{count}} h",
    "footerTaken": "pris",
    "footerRemaining": "restants",
    "storePurchases": "Ranger les achats",
    "storedPurchasesToast": "{{count}} article rangé au garde-manger",
    "storedPurchasesToast_other": "{{count}} articles rangés au garde-manger",
    "rayons": {
      "produce": "Fruits & légumes",
      "meat": "Viande & poisson",
      "fresh": "Frais",
      "grocery": "Épicerie",
      "other": "Autre"
    },
    "translationPending": "Traduction de l’ingrédient en cours"
  },
  "language": {
    "english": "English",
    "french": "Français",
    "changeLanguage": "Changer de langue",
    "currentLanguage": "Langue actuelle",
    "changing": "Changement de langue..."
  },
  "common": {
    "loading": "Chargement...",
    "error": "Erreur",
    "retry": "Réessayer",
    "ok": "OK",
    "yes": "Oui",
    "no": "Non",
    "minutes": "{{count}}min",
    "hours": "{{count}}h",
    "hoursAndMinutes": "{{hours}}h {{minutes}}min",
    "close": "Fermer",
    "done": "Terminé",
    "expiring": "expirent",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "confirm": "Confirmer",
    "search": "Rechercher",
    "dismiss": "Ignorer",
    "back": "Retour",
    "undo": "Annuler",
    "noItems": "Aucun article sélectionné",
    "selectAtLeastOne": "Veuillez accepter au moins un aliment à ajouter à votre garde-manger.",
    "gotIt": "Compris",
    "tapToRefresh": "Touchez pour rafraîchir",
    "pageNotFound": "Page introuvable",
    "itemNotFound": "Article introuvable",
    "viewList": "Voir la liste",
    "cooked": "CUISINÉ",
    "prep": "PRÉP",
    "total": "TOTAL",
    "today": "AUJOURD'HUI",
    "all": "Tout",
    "veggie": "Végé",
    "under30": "≤ 30 min",
    "ingredientsAdded_one": "{{count}} ingrédient ajouté à la liste",
    "ingredientsAdded_other": "{{count}} ingrédients ajoutés à la liste",
    "somethingWentWrong": "Un problème est survenu",
    "redirecting": "Redirection…"
  },
  "errors": {
    "signedOut": "Vous n'êtes plus connecté. Reconnectez-vous et réessayez.",
    "serverError": "Un problème est survenu de notre côté. Réessayez dans un instant.",
    "networkError": "Erreur réseau. Vérifiez votre connexion.",
    "unknownError": "Une erreur inattendue s'est produite.",
    "recipeNotFound": "Recette non trouvée.",
    "translationFailed": "Échec de la traduction. Veuillez réessayer.",
    "cameraPermission": "Permission d'accès à la caméra requise.",
    "imageProcessingFailed": "Échec du traitement de l'image.",
    "languageChangeFailed": "Échec du changement de langue. Veuillez réessayer."
  },
  "onboarding": {
    "brand": "Du Chef",
    "quiz": {
      "hello": "Bonjour, Chef ! Trois duels, et je bâtis vos recommandations personnalisées.",
      "haveAccount": "J'ai déjà un compte",
      "kicker": "Votre profil",
      "axis": {
        "base": "La base de vos repas",
        "time": "Le temps que vous y mettez",
        "heat": "L'intensité"
      },
      "question": {
        "q1": "Lequel des deux plats vous intéresse le plus ?",
        "q2": "Un soir de semaine, lequel ?",
        "q3": "Et pour finir ?"
      },
      "reaction": {
        "q1a": "Ok, la protéine reste au centre.",
        "q1b": "Ah, le végétal d'abord. Intéressant.",
        "q2a": "J'ai l'impression que vous voulez du rapide en semaine.",
        "q2b": "On dirait que le temps aux chaudrons ne vous dérange pas.",
        "q3a": "Vous semblez aimer ça relevé.",
        "q3b": "Plutôt doux, on s'entend."
      },
      "progress": "Question {{n}} / 3",
      "choose": "Choisissez",
      "ingredients": "{{count}} ingrédients",
      "minutes": "{{count}} min",
      "difficulty": {
        "facile": "facile",
        "moyen": "moyen",
        "technique": "technique"
      },
      "side": {
        "protein": "Protéine au centre",
        "vegetal": "Végétal d’abord",
        "bold": "Saveurs relevées",
        "mild": "Saveurs douces"
      }
    },
    "safety": {
      "kicker": "Avant que je propose quoi que ce soit",
      "prompt": "Des allergies importantes à savoir ?",
      "sectionKicker": "Allergies et intolérances",
      "allergen": {
        "arachides": "Arachides",
        "noix": "Noix",
        "crustaces": "Crustacés",
        "lactose": "Lactose",
        "gluten": "Gluten",
        "oeufs": "Œufs",
        "soja": "Soja",
        "poisson": "Poisson",
        "sesame": "Sésame"
      },
      "otherPlaceholder": "Autre allergie ou intolérance…",
      "add": "Ajouter",
      "nothing": "Rien à signaler",
      "confirm": "Confirmer",
      "beat": "Je dresse votre profil…",
      "beatReading": "Je relis vos choix…",
      "beatWeek": "Je monte votre semaine…",
      "beatAllergies": "Sans {{list}}",
      "beatNoAllergies": "Rien à éviter",
      "beatError": "Oups, on reprend.",
      "beatEmpty": "Vos exclusions ne laissent aucune recette dans votre bibliothèque. Retirez-en une et je vous construis votre semaine.",
      "retry": "Réessayer",
      "editExclusions": "Modifier mes exclusions",
      "promise": "Je n’en tiendrai jamais compte « à peu près » : un plat qui en contient ne sera jamais proposé, ni dans la semaine, ni dans la recherche."
    },
    "direction": {
      "kicker": "Votre profil est prêt",
      "title": "Que voulez-vous faire",
      "titleEmphasis": "maintenant",
      "titleEnd": " ?",
      "planCta": "Planifier ma semaine",
      "ideasCta": "Trouver un souper pour ce soir",
      "searchPlaceholder": "Poulet, riz, brocoli…",
      "chips": {
        "quick": "≤ 20 min",
        "fridge": "Dans mon frigo",
        "rated": "Bien notées",
        "veg": "Végé"
      },
      "nothingPlanned": "Rien de prévu",
      "planSub": "Sept soupers et la liste d’épicerie",
      "ideasSub": "Avec ce que vous avez déjà",
      "ideasSubPicked": "Des idées selon votre profil",
      "ideaMinutes": "{{minutes}} min",
      "bubble": "Je peux monter toute votre semaine, ou juste vous trouver quelque chose pour ce soir."
    },
    "profile": {
      "kicker": "Votre profil",
      "bubble": "Voici ce que j’ai compris. Corrigez-moi si je me trompe.",
      "axis": {
        "base": "La base",
        "time": "Le temps",
        "heat": "L’intensité"
      },
      "title": "Est-ce que ça vous ressemble ?",
      "flipHint": "Touchez une ligne qui ne vous ressemble pas, je la corrige.",
      "allergiesKicker": "Allergies et intolérances",
      "none": "Rien à signaler",
      "edit": "Modifier",
      "peopleKicker": "Vous cuisinez pour combien de personnes, d’habitude ?",
      "people_one": "personne",
      "people_other": "personnes",
      "fewer": "Une personne de moins",
      "more": "Une personne de plus",
      "confirm": "C’est moi"
    },
    "reading": {
      "base": {
        "protein": "On dirait que vous tenez à votre protéine : {{plate1}} plutôt que {{other1}}.",
        "vegetal": "J'ai l'impression que le végétal vous parle plus : {{plate1}} a passé avant {{other1}}."
      },
      "time": {
        "quick": "Et comme vous avez pris {{plate2}} ({{min2}} min) au lieu de {{other2}} ({{minOther2}} min), je suppose que vous n'avez pas envie de passer vos soirées aux chaudrons.",
        "long": "Et comme vous avez pris {{plate2}} et ses {{min2}} minutes, je me dis que cuisiner pour vrai ne vous dérange pas."
      },
      "heat": {
        "bold": "Je vous prépare des assiettes assez relevées. Dites-moi si je me trompe.",
        "mild": "Je reste dans le doux. Dites-moi si je me trompe."
      },
      "corrected": {
        "base": "Corrigé sur la base. Je rebâtis à partir de ça.",
        "time": "Corrigé sur le temps. Je rebâtis à partir de ça.",
        "heat": "Corrigé sur l'intensité. Je rebâtis à partir de ça."
      },
      "concretementKicker": "Concrètement",
      "concretement": {
        "protein-quick-bold": "je reste sur la poêle et le gril en semaine, marinades courtes, et je garde le four pour samedi.",
        "protein-quick-mild": "des cuissons rapides à la poêle, sauces au citron et aux herbes plutôt qu'au piment.",
        "protein-long-bold": "des braisages relevés la fin de semaine, et je vous préviens la veille de sortir la viande.",
        "protein-long-mild": "des rôtis doux qui travaillent tout seuls au four, et des restes pour le lendemain.",
        "vegetal-quick-bold": "des sautés au wok, épices franches, légumineuses pour la satisfaction — 20 minutes chaque fois.",
        "vegetal-quick-mild": "des bols de légumes tièdes, citron et herbes, rien qui pique.",
        "vegetal-long-bold": "des currys et des légumes rôtis longtemps, épices entières, beaucoup de restes.",
        "vegetal-long-mild": "des gratins de légumes et des soupes qui mijotent, tout en douceur."
      },
      "chip": {
        "base": {
          "protein": "Protéine d'abord",
          "vegetal": "Végétal d'abord"
        },
        "time": {
          "quick": "≤ 30 min en semaine",
          "long": "Le temps qu'il faut"
        },
        "heat": {
          "bold": "Saveurs relevées",
          "mild": "Saveurs douces"
        }
      },
      "hint": "Touchez une puce qui ne vous ressemble pas, je refais la semaine.",
      "close": "Fermer"
    }
  },
  "diet": {
    "vegetarian": "Végétarien",
    "vegetarianDesc": "Ni viande ni fruits de mer",
    "vegan": "Végétalien",
    "veganDesc": "Aucun produit animal",
    "glutenFree": "Sans gluten",
    "glutenFreeDesc": "Ni blé, ni orge, ni seigle",
    "dairyFree": "Sans produits laitiers",
    "dairyFreeDesc": "Ni lait, ni fromage, ni crème",
    "navTitle": "Préférences alimentaires",
    "dietType": "Type de régime",
    "excludedIngredients": "Ingrédients exclus",
    "noExcluded": "Aucun ingrédient exclu pour l'instant.",
    "mealFrequency": "Fréquence des repas",
    "noFrequency": "Aucune préférence de fréquence pour l'instant.",
    "addMore": "Ajouter",
    "addMoreHint": "ex. « Je suis allergique aux fruits de mer » ou « 2 repas végétariens par semaine »",
    "addMorePlaceholder": "Indiquez vos aversions, allergies ou fréquences...",
    "parse": "Analyser",
    "understood": "Nous avons compris — touchez pour retirer :",
    "nothingDetected": "Aucune préférence particulière détectée.",
    "save": "Enregistrer les préférences",
    "vegetarianPerWeek": "{{count}} végétarien/semaine",
    "fishPerWeek": "{{count}} poisson/semaine",
    "filterCoverage": "Végétarien est déterminé à partir des ingrédients, donc il filtre toute la bibliothèque. Sans gluten et sans produits laitiers se fient à ce que la recette déclare, et peu de recettes le font : attendez-vous à une liste bien plus courte. Vous pouvez lever un régime pour une session à partir de la pastille sur l'écran Recettes.",
    "lowLactose": "Faible en lactose",
    "healthy": "Santé"
  },
  "join": {
    "headline": "Votre partenaire vous a invité",
    "subline": "Planifiez vos repas, synchronisez votre liste d'épicerie et cuisinez ensemble.",
    "featurePlan": "Plan de repas hebdomadaire partagé",
    "featureGrocery": "Liste d'épicerie synchronisée en temps réel",
    "featureRecipes": "Enregistrez et notez des recettes ensemble",
    "featurePantry": "Un seul garde-manger, sans doublons",
    "createAccount": "Créer un compte gratuit",
    "haveAccount": "Déjà un compte ? Connectez-vous",
    "alreadyPairedTitle": "Vous êtes déjà jumelés",
    "alreadyPairedBody": "Vous et votre partenaire partagez déjà ce foyer.",
    "continue": "Continuer",
    "otherHouseholdTitle": "Vous êtes déjà dans un foyer",
    "otherHouseholdBody": "Vous ne pouvez faire partie que d'un seul foyer à la fois. Quittez votre foyer actuel pour accepter cette invitation.",
    "backToApp": "Retour à l'application",
    "headerTitle": "Rejoindre un foyer",
    "lookingUp": "Recherche de l'invitation…",
    "invitedTitle": "Vous avez été invité",
    "invitedSubtitle": "Vous partagerez le plan de repas, les recettes, la liste d'épicerie, les notes et le garde-manger.",
    "dataQuestion": "Et vos données ?",
    "mergeTitle": "Fusionner",
    "mergeBody": "Combiner mes recettes, listes et garde-manger avec les leurs. La dernière modification l'emporte sur les éléments communs.",
    "freshTitle": "Repartir à zéro",
    "freshBody": "Utiliser leur configuration. Rien de mes données n'est supprimé — je peux les récupérer plus tard.",
    "joining": "Ajout au foyer…",
    "cancel": "Annuler",
    "errMissingCode": "Code d'invitation manquant.",
    "errNotFound": "Invitation introuvable. Demandez à votre partenaire de renvoyer un lien.",
    "errUsed": "Cette invitation a déjà été utilisée.",
    "errExpired": "Cette invitation a expiré. Demandez à votre partenaire d'en renvoyer une.",
    "errLoad": "Impossible de charger l'invitation.",
    "errJoin": "Impossible de rejoindre le foyer."
  },
  "wizard": {
    "mealSlotQuestion": "Quels repas souhaitez-vous\ninclure pour ces jours ?",
    "dietaryTitle": "Des préférences alimentaires ?",
    "dietarySubtitle": "Sélectionnez les options qui s'appliquent à votre semaine",
    "vegetarian": "Végétarien",
    "vegetarianDesc": "Inclure au moins un repas végétarien",
    "fishSeafood": "Poisson/Fruits de mer",
    "fishSeafoodDesc": "Inclure au moins un repas de poisson ou fruits de mer",
    "surpriseMe": "Surprise !",
    "surpriseMeDesc": "Pas de préférence - laissez-moi découvrir de nouvelles recettes",
    "portionTitle": "Combien de portions par repas ?",
    "portionSubtitle": "Ceci s'appliquera à toutes les recettes générées",
    "servings": "portions",
    "custom": "personnalisé",
    "enterServings": "Entrez le nombre de portions",
    "back": "Retour",
    "next": "Suivant",
    "generate": "Générer",
    "generating": "Génération..."
  },
  "settings": {
    "subtitle": "Préférences et compte",
    "mealSchedule": "Planning des repas",
    "reset": "Réinitialiser",
    "mealScheduleDescription": "Définissez vos préférences pour chaque jour de la semaine. Le planificateur de repas les respectera lors de la génération de votre plan hebdomadaire.",
    "dinnerTime": "Heure du souper",
    "mealType": "Type de repas",
    "maxCookTime": "Temps de cuisson max",
    "noLimit": "Sans limite",
    "prepAheadOk": "Préparation à l'avance OK",
    "kidsPresent": "Enfants présents",
    "defaultServings": "Portions par défaut",
    "defaultServingsDescription": "Les nouveaux repas auront par défaut ce nombre de portions",
    "servings": "portions",
    "mealDietTypes": {
      "any": "Tous",
      "meat": "Viande",
      "vegetarian": "Végé",
      "fish": "Poisson",
      "pasta": "Pâtes",
      "quick": "Rapide"
    },
    "emailImportTitle": "Importer des recettes par courriel",
    "emailImportDescription": "Transférez n'importe quelle infolettre à cette adresse et Du Chef importera automatiquement les recettes.",
    "emailImportCopy": "Copier l'adresse",
    "emailImportCopied": "Copié !",
    "helpFeedback": "Aide et commentaires",
    "reportProblem": "Signaler un problème",
    "reportProblemDescription": "Quelque chose ne fonctionne pas ? Envoyez-nous une description et nous examinerons le problème.",
    "notifications": "Notifications",
    "dailyEmail": "Courriel quotidien Du Chef",
    "dailyEmailDesc": "Un mot chaque soir avec le plan du lendemain et un fait alimentaire.",
    "dietaryPreferences": "Préférences alimentaires",
    "noRestrictions": "Aucune restriction définie",
    "excludedIngredientCount": "{{count}} ingrédient exclu",
    "excludedIngredientCount_other": "{{count}} ingrédients exclus",
    "noExcludedIngredients": "Aucun ingrédient exclu",
    "kitchenStaples": "Essentiels de cuisine",
    "kitchenStaplesDesc": "Choisissez quels essentiels de cuisine nous supposons que vous avez en stock. Les essentiels activés (ON) n'apparaissent pas dans votre liste d'courses.",
    "excludedStapleCount": "{{count}} essentiel exclu",
    "excludedStapleCount_other": "{{count}} essentiels exclus",
    "noExcludedStaples": "Tous les essentiels sont supposés en stock",
    "syncing": "Synchronisation...",
    "syncComplete": "Synchronisation terminée",
    "forceSync": "Forcer la synchro des repas vers le nuage",
    "syncFailed": "Échec de la synchronisation. Veuillez réessayer.",
    "pantryTitle": "Garde-manger",
    "labs": {
      "title": "Labs",
      "description": "Fonctionnalités expérimentales. Visible uniquement pour vous.",
      "skylightDestination": "Calendrier familial",
      "push": "Envoyer la semaine du {{week}}",
      "noGroceryList": "Aucune liste d'épicerie générée",
      "weekNotPlanned": "Semaine du {{week}} non planifiée",
      "phaseRecipes": "Recettes… {{done}}/{{total}}",
      "phaseDeletions": "Nettoyage… {{done}}/{{total}}",
      "phaseMeals": "Repas… {{done}}/{{total}}",
      "phaseGroceries": "Épicerie… {{done}}/{{total}}",
      "done": "{{recipes}} recettes · {{meals}} repas · {{groceries}} lignes",
      "doneMealsSkipped": "Épicerie envoyée · repas ignorés",
      "doneNoMeals": "Épicerie envoyée · aucun repas envoyé pour cette semaine",
      "doneSomeMealsMissing": "Épicerie envoyée · {{count}} repas n'a pas pu être envoyé",
      "doneSomeMealsMissing_other": "Épicerie envoyée · {{count}} repas n'ont pas pu être envoyés",
      "unresolvedHint": "Leurs recettes sont introuvables. Le reste de la semaine est parti.",
      "failed": "Envoi interrompu — réessayer"
    },
    "myTasteTitle": "Mon goût",
    "myTasteEmpty": "À définir"
  },
  "tasteProfile": {
    "title": "Mon profil de goût",
    "signals": "{{count}} signaux",
    "updated": "Mis à jour le {{date}}",
    "noProfile": "Je n'ai encore rien appris",
    "noProfileText": "Donnez-moi votre avis sur mes suggestions (ignorez, remplacez ou modifiez un repas) et je commence à vous connaître.",
    "buildingProfile": "Je commence à vous connaître",
    "buildingProfileText": "J'ai {{count}} signal{{plural}}. Encore quelques gestes et j'écris ce que j'ai compris. Tire vers le bas pour rafraîchir.",
    "preferences": "Préférences",
    "recentInsights": "Observations récentes",
    "howItsImproving": "Comment ça s'améliore",
    "showLess": "Voir moins",
    "showMore": "Voir {{count}} de plus",
    "chosenTitle": "Ce que vous avez choisi",
    "chosenHint": "Touchez une ligne qui ne vous ressemble pas, je la corrige.",
    "chosenSaved": "Pris en note. Votre prochaine semaine en tiendra compte.",
    "declaredTitle": "Ce que vous m'avez interdit",
    "allergiesLabel": "Allergies et intolérances",
    "dietsLabel": "Régimes",
    "dietsNone": "Aucun régime déclaré",
    "excludedCount": "{{count}} ingrédient exclu",
    "excludedNone": "Aucun ingrédient exclu",
    "declaredNote": "Jamais proposé, jamais dans votre liste d'épicerie, même quand vous régénérez la semaine.",
    "learnedTitle": "Ce que j'ai compris en vous regardant",
    "learnedNote": "Je m'en sers pour classer mes suggestions, jamais pour exclure un plat.",
    "excludedCount_other": "{{count}} ingrédients exclus"
  },
  "addRecipe": {
    "title": "Ajouter une recette",
    "pastePlaceholder": "Lien d'une recette ou d'une vidéo",
    "invalidUrl": "Veuillez entrer un lien valide",
    "fetchingRecipe": "Récupération de la recette...",
    "analyzingVideo": "Analyse de la vidéo...",
    "videoHint": "Cela peut prendre 30 à 60 secondes",
    "savingRecipe": "Enregistrement dans vos recettes...",
    "addRecipeButton": "Ajouter à mes recettes",
    "addButton": "Ajouter",
    "tryAgain": "Réessayer",
    "loginRequired": "Vous devez vous connecter pour enregistrer des recettes",
    "logIn": "Se connecter",
    "ingredientsCount": "{{count}} ingrédients",
    "addManually": "Ajouter manuellement",
    "newRecipeTitle": "Nouvelle recette",
    "errorTimeout": "La récupération de cette recette est trop longue. Veuillez réessayer.",
    "errorNetwork": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "pasteText": {
      "title": "Collez plutôt la recette",
      "body": "Ouvrez la publication dans {{platform}}, copiez la recette depuis la légende ou les commentaires, puis collez-la ici.",
      "theApp": "l'application",
      "placeholder": "Ingrédients et étapes, tels qu'écrits dans la publication",
      "cta": "Importer ce texte"
    },
    "errors": {
      "blocked": "Ce site n'autorise pas l'importation automatique des recettes. Vous pouvez l'ajouter manuellement.",
      "unscrapable": "Ce site ne publie pas les détails de recette que nous pouvons lire. Vous pouvez ajouter la recette manuellement.",
      "extractionFailed": "Nous n'avons pas trouvé de recette sur cette page. Vérifiez le lien ou ajoutez la recette manuellement.",
      "loginWall": "Ce site réserve cette recette à ses membres inscrits. Vous pouvez l'ajouter manuellement.",
      "invalidUrl": "Ce lien ne semble pas mener à une recette. Veuillez le vérifier et réessayer.",
      "timeout": "La récupération de cette recette est trop longue. Veuillez réessayer.",
      "unknown": "Impossible de récupérer la recette à partir de ce lien.",
      "authRequired": "Créez un compte gratuit pour importer des recettes.",
      "quotaExceeded": "Vous avez atteint la limite d'importations pour aujourd'hui. Réessayez demain."
    },
    "linkDetected": "Lien copié",
    "pasteLink": "Coller le lien",
    "changeLink": "Un autre lien",
    "fromPhoto": "Photo",
    "takePhoto": "Caméra",
    "signInWall": {
      "title": "Créez un compte pour importer",
      "body": "L'importation enregistre la recette dans votre collection, il lui faut donc un endroit où vivre. Cela prend quelques secondes et votre menu vous suit.",
      "cta": "Créer un compte gratuit",
      "signIn": "J'ai déjà un compte",
      "keepBrowsing": "Plus tard",
      "scanTitle": "Créez un compte pour scanner une recette",
      "scanBody": "Lire la photo d'une recette et l'enregistrer dans votre collection demande un compte. C'est gratuit, et votre menu vous suit."
    },
    "anotherLinkPlaceholder": "Ou un autre lien",
    "paste": "Coller",
    "writeIt": "L'écrire",
    "saveFailed": "Impossible d'enregistrer la recette",
    "createFailed": "Impossible de créer la recette"
  },
  "recipeDetail": {
    "myRating": "Ma note",
    "prepTime": "Préparation",
    "cookTime": "Cuisson",
    "totalTime": "Temps total",
    "skillLevel": "Niveau",
    "estimatedCalories": "Cal. estimées",
    "ingredients": "Ingrédients",
    "haveAllIngredients": "Tous les ingrédients ?",
    "metric": "métrique",
    "imperial": "impérial",
    "adjusted": "Ajusté",
    "adjustedServings": "{{from}} → {{to}} portions",
    "reset": "rétablir",
    "resetToOriginal": "Rétablir la recette originale",
    "originallyValue": "à l'origine : {{value}}",
    "swap": "sub",
    "addToMealPlan": "Ajouter au planning",
    "instructionsNotAvailable": "Instructions non disponibles dans l'application.",
    "viewOnOriginalSite": "Voir sur le site original",
    "noInstructionsAdded": "Aucune instruction ajoutée",
    "updateFromSource": "Mettre à jour depuis {{source}}",
    "editRecipe": "Modifier la recette",
    "alreadyOnPlan": "● déjà au planning",
    "alreadyScheduledTitle": "Déjà prévu {{where}}",
    "alreadyScheduledSubtitle": "Déplacer ici ou ajouter une deuxième fois?",
    "moveHere": "Déplacer ici",
    "addAnother": "Ajouter une 2e fois",
    "movedToSlot": "Déplacé au {{mealType}} du {{date}}",
    "slotOccupiedTitle": "Cette case contient déjà un repas",
    "slotAlreadyHolds": "Déjà prévu : {{dishes}}.",
    "swapHere": "Échanger les deux",
    "slotFullReason": "Cette case contient déjà 3 plats",
    "entryOwnsSlotReason": "Cette journée est réservée à autre chose",
    "swappedWithSlot": "{{title}} échangé avec {{other}}",
    "replacedAtSlot": "{{title}} a remplacé {{other}}",
    "stackedAtSlot": "{{title}} ajouté avec {{other}}",
    "replaceHere": "Remplacer",
    "replaceSlot_one": "Remplacer",
    "replaceSlot_other": "Remplacer les {{count}}",
    "addToSlot": "Ajouter à la case",
    "logPastMeal": "ajouter un repas",
    "pastDayCookedTitle": "Vous avez cuisiné cette recette {{day}} ?",
    "pastDayCookedSubtitle": "Ce jour est passé. Si oui, je la note comme cuisinée ce jour-là.",
    "pastDayCookedYes": "Oui, je l’ai cuisinée",
    "pastDayCookedNo": "Non, choisir un autre jour",
    "pastMealsScrollHint": "↑ Repas passés",
    "cookHistoryCooked": "Cuisiné {{count}} fois",
    "cookHistoryCooked_other": "Cuisiné {{count}} fois",
    "cookHistoryLastCooked": "Dernière fois {{when}}",
    "cookHistoryNever": "Jamais cuisiné",
    "cookHistoryLastWeek": "la semaine dernière",
    "cookHistoryWeeksAgo": "il y a {{count}} semaine",
    "cookHistoryWeeksAgo_other": "il y a {{count}} semaines",
    "cookHistoryLongAgo": "il y a longtemps",
    "cookHistoryAll": "Tout →",
    "logCooked": "J'ai cuisiné",
    "coveragePrefix": "Il vous manque ",
    "ingredientWord": "ingrédient",
    "ingredientsWord": "ingrédients",
    "coverageAllPrefix": "Vous avez ",
    "coverageAllWord": "tout",
    "coverageAllSuffix": " pour cuisiner",
    "coverageSub": "Croisé avec votre garde-manger — les {{count}} autres, vous les avez déjà (basiques inclus).",
    "coverageSub_other": "Croisé avec votre garde-manger — les {{count}} autres, vous les avez déjà (basiques inclus).",
    "coverageSubAll": "Croisé avec votre garde-manger — basiques inclus.",
    "addBuyToGrocery": "Ajouter le {{count}} à l'épicerie",
    "addBuyToGrocery_other": "Ajouter les {{count}} à l'épicerie",
    "legendHave": "Déjà chez vous",
    "legendBuy": "À acheter",
    "editPantry": "Modifier mon garde-manger",
    "replaceRow": "remplacer",
    "replacing": "en cours",
    "correctionHaveQuestion": "Vous avez déjà « {{name}} » ?",
    "correctionHaveAction": "Je l'ai — ranger au garde-manger",
    "correctionOutQuestion": "Au garde-manger : « {{item}} »",
    "correctionOutAction": "Je n'en ai plus",
    "correctionOutNextQuestion": "Il reste « {{item}} ». Fini aussi ?",
    "correctionOutNextAction": "Oui, fini",
    "correctionOutNextKeep": "Non, j'en ai",
    "correctionStapleQuestion": "Basique présumé — plus en stock ?",
    "correctionStapleAction": "Ajouter à l'épicerie",
    "removedFromPantryToast": "{{name}} — retiré du garde-manger",
    "addedToPantryToast": "{{name}} — rangé au garde-manger",
    "share": "Partager",
    "linkCopied": "Lien copié",
    "shareInPaprika": "Dans Du Chef :",
    "more": "Plus",
    "favorite": "Favori",
    "logCook": "Noter une cuisson",
    "openOnSource": "Ouvrir sur {{source}}",
    "sourceFallback": "le site source",
    "viewInPlan": "Voir au plan",
    "cookMode": "Mode cuisson",
    "plan": "Planifier",
    "showMore": "Lire la suite",
    "showLess": "Réduire",
    "deleteTitle": "Supprimer la recette",
    "deleteConfirm": "Voulez-vous vraiment supprimer « {{title}} » ? Cette action est irréversible.",
    "deleted": "Recette supprimée : « {{title}} »",
    "servingsCount_one": "{{count}} portion",
    "servingsCount_other": "{{count}} portions",
    "durationMinutes_one": "{{count}} min",
    "durationMinutes_other": "{{count}} min",
    "durationHours_one": "{{count}} h",
    "durationHours_other": "{{count}} h",
    "cookedTimes_one": "Cuisiné {{count}} fois",
    "cookedTimes_other": "Cuisiné {{count}} fois",
    "cookedLastTime": "dernière fois le {{date}}",
    "buyPill_one": "{{count}} à acheter",
    "buyPill_other": "{{count}} à acheter",
    "nothingInPantry": "Rien de tout ça au garde-manger.",
    "restInPantry_one": "L'autre est à votre garde-manger.",
    "restInPantry_other": "Les {{count}} autres sont à votre garde-manger.",
    "haveEverything": "Vous avez tout pour cuisiner.",
    "slotMorning": "matin",
    "slotNoon": "midi",
    "slotEvening": "soir",
    "addBuyToGrocery_one": "Ajouter le {{count}} à l'épicerie",
    "loading": "Chargement de la recette…",
    "notFound": "Recette introuvable",
    "loadFailed": "Impossible de charger cette recette",
    "noIngredientsListed": "Aucun ingrédient indiqué",
    "fetchingFromSource": "Récupération depuis la source…",
    "dataError": {
      "section": {
        "ingredients": "les ingrédients",
        "steps": "les étapes"
      },
      "openSource": "Ouvrir la source",
      "editManually": "Modifier manuellement",
      "blocked": {
        "title": "Ce site bloque l'accès automatisé",
        "body": "Le site source n'autorise pas l'extraction. Ouvrez la recette d'origine pour copier les détails manuellement."
      },
      "network": {
        "title": "Impossible de joindre la source",
        "body": "La requête a expiré ou le site est temporairement indisponible. Vérifiez votre connexion et réessayez."
      },
      "notFound": {
        "title": "Impossible d'extraire la recette",
        "body": "La page s'est chargée mais {{section}} n'étaient pas dans un format reconnaissable. Réessayez, ouvrez l'original, ou ajoutez-les manuellement."
      },
      "signIn": {
        "title": "Créez un compte pour charger cette recette",
        "body": "Du Chef va chercher la recette sur le site d'origine, et il lui faut un compte pour ça. C'est gratuit."
      }
    },
    "moveMealTitle": "Déplacer ce repas",
    "mealIsHere": "Ce repas est ici",
    "planSecondTime": "Planifier une 2ᵉ fois",
    "removeFromPlan": "Retirer du plan",
    "removedFromPlan": "Retiré du plan",
    "addedToSlot": "Ajouté au {{mealType}} du {{date}}",
    "planFailed": "Impossible d’ajouter au plan",
    "addIngredient": "Ajouter un ingrédient",
    "addStep": "Ajouter une étape",
    "changePhoto": "Changer la photo",
    "deleteRecipe": "Supprimer la recette",
    "descriptionLabel": "DESCRIPTION",
    "descriptionPlaceholder": "Une courte description…",
    "editHint": "Vos changements ne sont enregistrés qu’en validant.",
    "noSubstitutes": "Aucune alternative courante pour cet ingrédient.",
    "replace": "REMPLACER",
    "servings": "PORTIONS",
    "servingsLabel": "PORTIONS",
    "stepPlaceholder": "Décrivez cette étape…",
    "steps": "Préparation",
    "substituteFooter": "Le choix met à jour votre liste d’épicerie.",
    "substituteHint": "Ajustez la quantité selon la note.",
    "titleLabel": "TITRE",
    "use": "Utiliser",
    "used": "Utilisé",
    "veg": "végé",
    "savedToast": "Un nouveau festin en puissance dans votre bibliothèque !",
    "mustBeLoggedIn": "Vous devez être connecté pour modifier des recettes",
    "noItemsToAdd": "Aucun article à ajouter",
    "addToGroceryFailed": "Impossible d'ajouter les articles à l'épicerie",
    "recipeUpdated": "Recette mise à jour avec les données manquantes",
    "alreadyInPantryToast": "{{name}} — déjà au garde-manger",
    "alreadyInPantryAsToast": "{{name}} — déjà au garde-manger : {{existing}}",
    "stapleNotShelvedToast": "{{name}} — basique, toujours compté comme en stock",
    "notShelvedToast": "{{name}} — impossible à ranger au garde-manger",
    "coverageQuestion": "Utiliser « {{item}} » pour « {{need}} » ?",
    "coverageYes": "Oui, j'en ai assez",
    "coverageNo": "Non, à acheter",
    "inYourPantry": "Dans votre garde-manger",
    "otherOptions": "Autres options",
    "moreCookNotes_one": "{{count}} autre note",
    "moreCookNotes_other": "{{count}} autres notes",
    "coverageYield": "{{owned}} ≈ {{available}} {{unit}}",
    "coverageYieldNeeded": "{{owned}} ≈ {{available}} {{unit}} — il en faut {{needed}}",
    "watch": "Regarder",
    "watchOriginalVideo": "Voir la vidéo d'origine",
    "newRecipeTitle": "Nouvelle recette",
    "newRecipeHint": "Rien n’est gardé avant d’enregistrer.",
    "addPhoto": "Ajouter une photo",
    "titlePlaceholder": "Nom de la recette",
    "ingredientLinePlaceholder": "ex. 3 L de sauce tomate",
    "removeIngredient": "Retirer cet ingrédient",
    "ingredientReadAs": "Lu comme",
    "sourceLabel": "SOURCE (FACULTATIF)",
    "sourceAuthorLabel": "AUTEUR",
    "sourceAuthorPlaceholder": "Qui a écrit la recette",
    "sourceLinkLabel": "LIEN",
    "addUnit": "+ unité",
    "addQuantity": "+ quantité",
    "ingredientCorrected": "Corrigé",
    "unitLabel": "UNITÉ",
    "unitNone": "aucune",
    "unitOther": "Autre…",
    "unitOtherPlaceholder": "ex. filet",
    "quantityLabel": "QUANTITÉ",
    "quantityLess": "Moins",
    "quantityMore": "Plus"
  },
  "recipeTime": {
    "handsOn": "Préparation",
    "ready": "Prêt en",
    "moments_one": "en {{count}} moment",
    "moments_other": "en {{count}} moments",
    "oneGo": "d'un trait",
    "noWait": "rien à attendre",
    "waitCaption": {
      "marinade": "dont {{range}} de marinade au frigo",
      "fridge": "dont {{range}} au frigo",
      "rise": "dont {{range}} de levée",
      "rest": "dont {{range}} de repos",
      "soak": "dont {{range}} de trempage",
      "cure": "dont {{range}} de cure au frigo",
      "freeze": "dont {{range}} au congélateur",
      "oven": "dont {{range}} au four",
      "simmer": "dont {{range}} à mijoter",
      "slow-cooker": "dont {{range}} à la mijoteuse",
      "other": "dont {{range}} d'attente"
    },
    "cardHandsOn": "Préparation {{time}}",
    "cardReady": "Prêt en {{time}}",
    "rangeMinutes": "{{min}} à {{max}} min",
    "rangeHours": "{{min}} à {{max}} h",
    "rangeMixed": "{{min}} à {{max}}",
    "rangeUpTo": "jusqu'à {{max}}"
  },
  "generationSummary": {
    "howPlanBuilt": "Comment votre plan a été construit",
    "tasteMeals": "{{count}} repas correspond à vos préférences gustatives",
    "tasteMeals_other": "{{count}} repas correspondent à vos préférences gustatives",
    "inventoryMeals": "{{count}} repas utilise des articles de votre garde-manger",
    "inventoryMeals_other": "{{count}} repas utilisent des articles de votre garde-manger",
    "dealsIncluded": "{{count}} offre incluse cette semaine",
    "dealsIncluded_other": "{{count}} offres incluses cette semaine",
    "cuisineVariety": "{{count}} cuisines différentes cette semaine",
    "coverageSummary": "Couverture moy. {{avgPercent}}% — {{toBuyCount}} articles à acheter pour {{mealCount}} repas"
  },
  "weekRecap": {
    "title": "Bilan de la semaine",
    "noMeals": "Aucun repas trouvé pour cette semaine.",
    "noneCooked": "Appuyez sur chaque repas cuisiné cette semaine, puis notez-le.",
    "summary": "Vous avez cuisiné {{cooked}} de {{total}} repas prévus.",
    "done": "Terminé",
    "cooked": "Cuisiné",
    "notCooked": "Pas cuisiné"
  },
  "feedback": {
    "badgeLabel": "ALPHA",
    "sheetTitle": "Partager un retour",
    "sheetSubtitle": "Vous êtes testeur alpha — vos retours façonnent la suite.",
    "bug": {
      "label": "Quelque chose ne fonctionne pas",
      "description": "Signaler un bug ou un comportement inattendu",
      "placeholder": "Que s'est-il passé ? Qu'attendiez-vous à la place ?"
    },
    "feature": {
      "label": "Idée de fonctionnalité",
      "description": "Suggérer quelque chose qui vous aiderait",
      "placeholder": "Qu'est-ce qui améliorerait cette application ?"
    },
    "impression": {
      "label": "Impression rapide",
      "description": "Une remarque générale ou un commentaire",
      "placeholder": "Qu'avez-vous en tête ?"
    },
    "send": "Envoyer le retour",
    "retry": "Réessayer",
    "error": "Votre retour n'a pas pu être envoyé. Il est toujours là — vérifiez votre connexion et réessayez.",
    "success": "Merci pour votre retour !"
  },
  "cookingPlan": {
    "dinner": "Dîner",
    "pantryAutoUpdated": "Garde-manger mis à jour automatiquement",
    "removedFromPantry": "Retiré du garde-manger",
    "viewPantry": "Voir le garde-manger",
    "undoUpdate": "Annuler la mise à jour",
    "yesWithoutUpdate": "Oui, sans mise à jour",
    "noNotCooked": "Non, pas cuisiné",
    "noItemsMatched": "Aucun article du garde-manger n'a pu être associé.",
    "depleted": "épuisé",
    "updating": "Mise à jour…",
    "yesUpdatePantry": "Oui, mettre à jour le garde-manger",
    "cookedQuestion": "Avez-vous cuisiné {{recipe}} ?",
    "thisMeal": "ce repas",
    "updatePantryHint": "Vous pouvez mettre à jour votre garde-manger automatiquement.",
    "staplesNotTracked": "Sel, poivre, huile & herbes — non suivis.",
    "resume": "Reprendre la cuisson",
    "planThisMeal": "Planifier ce repas",
    "startMeta": "≈ {{minutes}} min · {{steps}}"
  },
  "recipe": {
    "translating": "Traduction en cours…",
    "showTranslation": "Traduction"
  },
  "pantry": {
    "title": "Garde-manger",
    "itemsCount_one": "{{count}} article",
    "itemsCount_other": "{{count}} articles",
    "upToDate": "à jour",
    "autoLine": "Se met à jour tout seul — ajouté à l'achat, retiré quand vous cuisinez.",
    "added": {
      "today": "Ajouté aujourd'hui",
      "yesterday": "Ajouté hier",
      "days_one": "Ajouté il y a {{count}} j",
      "days_other": "Ajouté il y a {{count}} j",
      "on": "Ajouté le {{date}}"
    },
    "import": {
      "title": "Panier Lufa du {{date}}",
      "titleNoDate": "Panier Lufa",
      "subtitle_one": "{{count}} aliment ajouté",
      "subtitle_other": "{{count}} aliments ajoutés",
      "cta": "Vérifier",
      "dismiss": "Ignorer",
      "reviewSub": "Décochez ce qui n'est pas arrivé · touchez l'espace pour le déplacer",
      "later": "Plus tard",
      "keep_one": "Garder {{count}} aliment",
      "keep_other": "Garder {{count}} aliments",
      "reviewedToast_one": "Panier vérifié · {{count}} aliment au garde-manger",
      "reviewedToast_other": "Panier vérifié · {{count}} aliments au garde-manger"
    },
    "mySpaces": "Mes espaces",
    "arrangedLikeKitchen": "Rangé comme votre cuisine",
    "fourSpacesHint": "Quatre espaces · ajoutez où vous voulez",
    "dragHint": "Glissez un article entre les espaces · survolez pour gérer",
    "zones": {
      "fridge": "Frigo",
      "freezer": "Congélateur",
      "counter": "Comptoir",
      "pantry": "Garde-manger"
    },
    "zoneCond": {
      "fridge": "3°",
      "freezer": "−18°",
      "counter": "ambiante",
      "pantry": "sec"
    },
    "zoneUpToDate": "à jour",
    "zoneEmpty": "Cet espace est vide.\nPhotographiez-le ou ajoutez à la main.",
    "zoneEmptyDesktop": "Vide — photographiez ou ajoutez.",
    "freshness": {
      "urgent": "À utiliser",
      "soon": "Cette semaine",
      "fresh": "Frais",
      "stable": "longue conserve",
      "review": "à confirmer",
      "expiredYesterday": "expiré hier",
      "expiredDays": "expiré · {{count}} j",
      "today": "aujourd'hui",
      "tomorrow": "demain",
      "days": "~{{count}} jours",
      "oneWeek": "~1 semaine",
      "twoWeeks": "~2 semaines",
      "threeWeeks": "~3 semaines",
      "oneMonth": "~1 mois",
      "twoMonths": "~2 mois",
      "threeMonths": "~3 mois",
      "sixMonths": "~6 mois",
      "aYear": "~1 an"
    },
    "cats": {
      "protein": "Protéine",
      "vegetable": "Légume",
      "fruit": "Fruit",
      "dairy": "Laitier",
      "bread": "Pain",
      "condiment": "Condiment",
      "spice": "Épice",
      "staple": "Réserve",
      "beverage": "Boisson",
      "leftover": "Reste"
    },
    "cook": {
      "stripTitle_one": "{{count}} à utiliser cette semaine",
      "stripTitle_other": "{{count}} à utiliser cette semaine",
      "stripEmpty": "rien pour l'instant",
      "stripCta": "Cuisiner",
      "screenTitle": "À utiliser",
      "screenSub": "Protéines, légumes et pains d'abord",
      "cookThis": "Cuisiner ça",
      "eaten": "Mangé",
      "nothingUrgent": "Rien ne presse cette semaine",
      "nothingUrgentSub": "Tout votre frais a le temps.",
      "recipesTitle": "Cuisiner le {{name}}",
      "recipesSub": "Recettes qui l'utilisent · planifiez-en une pour l'écouler",
      "haveIngredients": "vous avez {{have}}/{{total}} ingrédients",
      "addToMeal": "Ajouter à un repas"
    },
    "item": {
      "stillGood": "Encore bon",
      "plusThreeDays": "+3 jours",
      "eatenDone": "Mangé / fini",
      "tossed": "Jeté",
      "update": "Mettre à jour",
      "move": "Déplacer",
      "moveTitle": "Déplacer « {{name}} »",
      "moveSub": "Actuellement au {{zone}} · touchez le nouvel espace.",
      "currentlyHere": "ici actuellement",
      "opened": "Entamé",
      "openedHint": "Raccourcit l'estimation",
      "markedOpened": "Marqué entamé",
      "markedSealed": "Marqué scellé",
      "freshnessUpdated": "Fraîcheur mise à jour",
      "freshnessExtended": "Fraîcheur prolongée · +3 jours",
      "movedTo": "{{name}} déplacé vers {{zone}}",
      "eatenToast": "{{name}} · mangé",
      "tossedToast": "{{name}} · jeté",
      "removedToast": "{{name}} · retiré",
      "undo": "Annuler",
      "fallbackTitle": "Article"
    },
    "add": {
      "whereTitle": "Ajouter où ?",
      "toZone": "Ajouter au {{zone}}",
      "addPanelSub": "Photographiez l'espace, cherchez, ou piochez dans les récents",
      "photoSpace": "Photographier l'espace",
      "photoAuto": "Détection auto des aliments",
      "photo": "Photo",
      "photograph": "Photographier",
      "addManual": "Ajouter",
      "searchPlaceholder": "Rechercher un aliment…",
      "recents": "Récents",
      "receipt": "Scanner un reçu",
      "receiptLong": "Scanner un reçu d'épicerie",
      "receiptAuto": "Rangé automatiquement dans les bons espaces",
      "addedToZone": "{{name}} ajouté au {{zone}}",
      "addedCount_one": "{{count}} article ajouté",
      "addedCount_other": "{{count}} articles ajoutés",
      "addedCountZone_one": "{{count}} article ajouté au {{zone}}",
      "addedCountZone_other": "{{count}} articles ajoutés au {{zone}}",
      "addedWithDups": "{{added}} ajoutés · {{dups}} déjà présents",
      "alreadyPresent": "déjà présent · quantité mise à jour",
      "alreadyInCapture": "même aliment, déjà sur cette photo"
    },
    "capture": {
      "receiptTitle": "Reçu d'épicerie",
      "aimHintReceipt": "Cadrez votre reçu d'épicerie et prenez la photo",
      "aimHintZone": "Cadrez votre {{zone}} et prenez la photo",
      "analyzing": "Analyse en cours…",
      "analyzingSub": "Du Chef identifie les aliments",
      "detected_one": "{{count}} article détecté",
      "detected_other": "{{count}} articles détectés",
      "reviewSubReceipt": "Rangés automatiquement · touchez l'espace pour corriger",
      "reviewSubZone": "Pour le {{zone}} · décochez au besoin",
      "cancel": "Annuler",
      "confirm_one": "Ajouter {{count}} article",
      "confirm_other": "Ajouter {{count}} articles",
      "whereTitle": "Où ranger",
      "changeZone": "Espace de rangement : {{zone}}. Toucher pour changer."
    },
    "empty": {
      "heroTitle": "Créons votre garde-manger",
      "heroSub": "Le plus rapide : scannez un reçu d'épicerie ou photographiez un espace. Du Chef range et suit la fraîcheur pour vous.",
      "receiptCta": "Scanner un reçu d'épicerie",
      "receiptCtaSub": "Tout l'achat en une photo",
      "orPhotograph": "Ou photographiez un espace",
      "preview": "Ce qui périme en premier, en haut",
      "previewSub": "· suivi tout seul, sans dates à taper",
      "manual": "Ajouter à la main",
      "seed": "Charger cet exemple",
      "seedDesktop": "Charger cet exemple pour explorer",
      "demoBanner": "Exemple de démonstration.",
      "demoBannerSub": "Voici à quoi ressemble un garde-manger rempli.",
      "demoRemove": "Retirer l'exemple",
      "receiptCtaSubGuest": "Avec un compte gratuit · tout l'achat en une photo",
      "orPhotographGuest": "Ou photographiez un espace · avec un compte"
    },
    "review": {
      "entry": "Revue éclair",
      "entrySub_one": "{{count}} article à confirmer",
      "entrySub_other": "{{count}} articles à confirmer",
      "entryCta": "Réviser",
      "panelSub": "{{current}} / {{total}} · ~20 s pour rester à jour",
      "stillThere": "Toujours là ?",
      "stillGoodQ": "Encore bon ?",
      "expiredNote": "Expiré depuis peu — certains aliments tiennent quelques jours de plus.",
      "addedAgo_one": "Ajouté il y a {{count}} jour et jamais confirmé.",
      "addedAgo_other": "Ajouté il y a {{count}} jours et jamais confirmé.",
      "yesStillThere": "Oui, encore là",
      "yesPlusDays": "Oui, +5 jours",
      "doneTossed": "Fini / jeté",
      "allDone": "Garde-manger à jour"
    },
    "plan": {
      "title": "Ajouter à un repas",
      "sub": "« {{recipe}} » · touchez une case de la semaine.",
      "replaceHint": "Une case occupée sera remplacée · annulable.",
      "placed": "« {{recipe}} » planifié · {{day}} · {{meal}}",
      "replaced": "« {{recipe}} » → {{day}} · {{meal}} (remplace {{prev}})"
    },
    "tidy": {
      "entry": "À ranger",
      "entrySub_one": "{{count}} chose à régler",
      "entrySub_other": "{{count}} choses à régler",
      "entryCta": "Ouvrir",
      "title": "Ranger le garde-manger",
      "panelSub_one": "{{count}} chose à régler",
      "panelSub_other": "{{count}} choses à régler",
      "certainTitle": "Doublons",
      "certainIntro": "Ces entrées sont le même aliment sous des noms différents. Décochez celles qui sont vraiment distinctes.",
      "maybeTitle": "Peut-être des doublons",
      "maybeIntro": "Ceux-ci se ressemblent, sans certitude. Votre réponse est retenue : la question ne reviendra pas.",
      "sortTitle": "À classer",
      "sortIntro": "Impossible de deviner où vont ces aliments. Choisissez, et ce choix vaudra pour les prochains.",
      "same": "Le même",
      "different": "Différents",
      "absorbs": "fusionne : {{names}}",
      "expiryNote": "La ligne fusionnée garde la date d'expiration la plus proche, pour ne rien faire passer pour plus frais qu'il ne l'est.",
      "cancel": "Annuler",
      "confirm_one": "Appliquer {{count}} choix",
      "confirm_other": "Appliquer {{count}} choix",
      "none": "Rien à ranger.",
      "done_one": "{{count}} ligne réglée",
      "done_other": "{{count}} lignes réglées"
    },
    "clear": {
      "row_one": "Vider le garde-manger · {{count}} aliment",
      "row_other": "Vider le garde-manger · {{count}} aliments",
      "button_one": "Vider le garde-manger ({{count}} aliment)",
      "button_other": "Vider le garde-manger ({{count}} aliments)",
      "explainer": "Retire tous les aliments de votre garde-manger, sur cet appareil et sur tous les autres. Ce que vous avez déjà mangé ou jeté est conservé.",
      "busy": "Suppression…",
      "confirmTitle": "Vider votre garde-manger ?",
      "confirmBody_one": "{{count}} aliment sera retiré partout, et c'est irréversible. Votre historique (mangé, jeté) est conservé.",
      "confirmBody_other": "{{count}} aliments seront retirés partout, et c'est irréversible. Votre historique (mangé, jeté) est conservé.",
      "confirmAction": "Vider",
      "done": "Votre garde-manger est vide.",
      "localOnly": "Vidé sur cet appareil. Le serveur n'a pas répondu, les aliments pourraient revenir à la prochaine ouverture — réessayez une fois en ligne."
    }
  },
  "weekly": {
    "counterItemsToBuyForMeals_one": "{{items}} à acheter pour {{count}} repas",
    "counterItemsToBuyForMeals_other": "{{items}} à acheter pour {{count}} repas",
    "counterAllCovered": "Tout est au garde-manger",
    "counterSubAllCovered": "pour ce repas · rien à acheter",
    "counterSubAllCovered_other": "pour vos {{count}} repas · rien à acheter",
    "shopThisWeek": "Faire l'épicerie de cette semaine",
    "shopThisWeekSub_one": "{{count}} repas planifié",
    "shopThisWeekSub_other": "{{count}} repas planifiés",
    "addBreakfast": "Ajouter un déjeuner",
    "addLunch": "Ajouter un dîner",
    "addDinner": "Ajouter un souper"
  },
  "editRecipe": {
    "saved": "Recette enregistrée.",
    "saveFailed": "Impossible d’enregistrer la recette. Veuillez réessayer.",
    "closeMenu": "Fermer le menu",
    "deleteFailed": "Impossible de supprimer la recette",
    "handsOnLabel": "Préparation (min)",
    "readyInLabel": "Prêt en (min)",
    "timeHandsOnExceedsReady": "La préparation ne peut pas dépasser le temps total",
    "timeNotANumber": "Entrez un nombre de minutes"
  },
  "editItem": {
    "title": "Modifier l'article",
    "subtitle": "Modifiez les détails de votre aliment",
    "itemName": "Nom de l'article",
    "category": "Catégorie",
    "quantity": "Quantité",
    "expiryDate": "Date d'expiration",
    "clearExpiryHint": "Laissez vide pour retirer la date d'expiration",
    "saveChanges": "Enregistrer les modifications"
  },
  "planRecipe": {
    "title": "Planifier cette semaine",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "thisWeekend": "Ce week-end",
    "orPickADay": "Ou choisissez un jour"
  },
  "importReview": {
    "title": "Révision",
    "adminOnly": "Cet écran est réservé aux administrateurs.",
    "loadFailed": "Impossible de charger les recettes à réviser.",
    "publishFailed": "Échec de la publication.",
    "publishSelected": "Publier {{count}} recette",
    "publishSelected_other": "Publier {{count}} recettes",
    "publishSuccess": "{{count}} recette publiée dans la bibliothèque partagée",
    "publishSuccess_other": "{{count}} recettes publiées dans la bibliothèque partagée",
    "publishPartial": "{{published}} publiée(s), {{skipped}} ignorée(s)",
    "subtitle": "Ce qu'on publie doit être juste. Chaque étiquette réglée ici entraîne aussi l'IA.",
    "entry": "Révision",
    "entryCount": "Révision · {{count}}",
    "filters": {
      "to-check": "À vérifier",
      "looks-right": "Semblent justes",
      "ready-to-publish": "Prêtes à publier",
      "done": "Réglées"
    },
    "sources": {
      "all": "Toutes les sources",
      "import": "Nouveaux imports",
      "library": "Ma bibliothèque",
      "catalogue": "Catalogue"
    },
    "sourceLabel": {
      "import": "Nouvel import",
      "library": "Ma bibliothèque",
      "catalogue": "Catalogue"
    },
    "legend": {
      "confirmed": "confirmée par vous",
      "sure": "l'IA est sûre",
      "unsure": "l'IA hésite : touchez pour vérifier",
      "missing": "manquante",
      "auto": "acceptée sans être regardée"
    },
    "toCheck_one": "{{count}} à vérifier",
    "toCheck_other": "{{count}} à vérifier",
    "blockedAccept": "Étapes ou ingrédients manquants",
    "acceptHint": "Puis prête à publier",
    "glance_one": "Celle-ci semble juste",
    "glance_other": "Ces {{count}} semblent justes",
    "glanceHint": "Regardez les photos et les étiquettes à l'écran, puis confirmez-les d'un seul geste.",
    "glanceDone_one": "{{count}} recette confirmée",
    "glanceDone_other": "{{count}} recettes confirmées",
    "glanceSkipped_one": "{{count}} a changé depuis le chargement et reste à vérifier",
    "glanceSkipped_other": "{{count}} ont changé depuis le chargement et restent à vérifier",
    "loadMore": "Afficher plus",
    "emptyFilter": {
      "to-check": "Rien à vérifier.",
      "looks-right": "Rien à confirmer d'un coup d'œil.",
      "ready-to-publish": "Rien de prêt à publier.",
      "done": "Rien de réglé pour l'instant."
    },
    "gaps": {
      "ingredients": "Aucun ingrédient",
      "steps": "Aucune étape",
      "image": "Aucune photo"
    },
    "addPhoto": "Ajouter une photo",
    "photoFailed": "La photo n'a pas pu être téléversée.",
    "refetch": "Relire la page",
    "refetchFound": "Trouvé sur la page : {{fields}}",
    "refetchNothing": "Rien de nouveau sur la page",
    "refetchUnreadable": "La page n'a pas pu être lue",
    "refetchNoSource": "Aucune page source à lire",
    "aiGuess": "Proposition de l'IA",
    "auto": "auto",
    "edit": "Modifier",
    "reject": "Rejeter",
    "loop": {
      "title": "L'IA, jugée par vos révisions",
      "meta": "prompt {{version}} · {{days}} derniers jours",
      "field": "{{field}} {{percent}} %",
      "glance": "coup d'œil {{percent}} %",
      "noAnswers": "aucune réponse encore",
      "mostCorrected": "Correction la plus fréquente : {{field}} {{from}} → {{to}} ({{count}})",
      "timeError": "écart typique {{minutes}} min"
    }
  },
  "entryForm": {
    "diningTitle": "Resto ou livraison",
    "noteTitle": "Repas simple",
    "whereLabel": "Où ?",
    "noteLabel": "Note (facultatif)",
    "eatingLabel": "Qu'est-ce que vous mangez ?",
    "placePlaceholder": "Ex. Pizza chez Nino",
    "notePlaceholder": "Ex. réservation 19 h",
    "textPlaceholder": "Ex. Sandwich au thon",
    "defaultPlace": "Au restaurant",
    "diningPresets": [
      "Resto",
      "Livraison",
      "Sortie",
      "Chez la famille",
      "Brunch"
    ],
    "notePresets": [
      "Sandwich au thon",
      "Omelette",
      "Pâtes au beurre",
      "Croque-monsieur",
      "Soupe et pain",
      "Plat du congélo"
    ]
  },
  "mealConfig": {
    "weekSettings": "Réglages de la semaine",
    "weekSettingsShort": "Réglages semaine",
    "appliesByDefault": "S'appliquent par défaut à chaque repas.",
    "defaultPortions": "Portions par défaut",
    "targetMix": "Répartition visée",
    "softGuide": "Guide souple — l'algo s'en approche.",
    "fish": "Poisson",
    "veggie": "Végé",
    "meat": "Viande",
    "quickSelect": "Sélection rapide :",
    "allDinners": "Tous les soupers",
    "allLunches": "Tous les dîners",
    "wholeWeek": "Toute la semaine",
    "dinners": "Soupers",
    "lunches": "Dîners",
    "clear": "Effacer",
    "weekDefault": "Défaut de la semaine",
    "mealType": "Type de repas",
    "removeThisMeal": "Retirer ce repas",
    "dontSuggestHere": "Ne pas suggérer ici",
    "planMyWeek": "Planifier ma semaine",
    "planShort": "Planifier",
    "yourSuggestions": "Vos suggestions",
    "configHint": "Touchez les repas à planifier, puis réglez portions et type par case.",
    "generatingHint": "Votre semaine se remplit — vous pourrez tout ajuster ensuite.",
    "generating": "Génération en cours…",
    "loadingRecipes": "Chargement des recettes…",
    "tapToChoose": "Touchez des cases pour choisir les repas à suggérer",
    "selectMeals": "Sélectionnez des repas",
    "mealSelected": "{{count}} repas sélectionné",
    "mealSelected_other": "{{count}} repas sélectionnés",
    "generateSuggestion": "Générer {{count}} suggestion",
    "generateSuggestion_other": "Générer {{count}} suggestions",
    "anotherRecipe": "Autre recette",
    "auto": "Auto",
    "affinity": {
      "title": "Je vous fais vos suggestions pour la semaine",
      "resembles": "ça vous ressemble",
      "keptFor": "gardé pour {{day}}",
      "reviewedLabel_one": "recette regardée",
      "reviewedLabel_other": "recettes regardées",
      "finalists_one": "{{count}} finaliste",
      "finalists_other": "{{count}} finalistes",
      "kept_one": "{{count}} gardée",
      "kept_other": "{{count}} gardées",
      "preparing": "Je prépare votre semaine…",
      "ready_one": "Votre semaine est prête · {{count}} repas",
      "ready_other": "Votre semaine est prête · {{count}} repas",
      "factAvoid": "Sans {{item}}",
      "factPantry": "Frigo · {{items}}",
      "factTime": "{{day}} · {{minutes}} min",
      "factHistory": "Pas vu la semaine passée",
      "factDiet": "Semaine · {{kind}} ×{{count}}",
      "kindVeg": "végé",
      "kindFish": "poisson",
      "kindMeat": "viande"
    }
  },
  "cookLog": {
    "cancel": "Annuler",
    "captureSubtitle": "On l'ajoute à votre historique.",
    "captureTitle": "Comment c'était ?",
    "cookedOn": "CUISINÉ LE",
    "noteLabel": "UNE NOTE POUR LA PROCHAINE FOIS",
    "notePlaceholder": "Doubler la vinaigrette la prochaine fois…",
    "notesHeader": "Vos notes",
    "optional": "facultatif",
    "save": "Enregistrer au journal",
    "today": "Aujourd'hui",
    "yourRating": "VOTRE NOTE",
    "ratingLabels": [
      "",
      "Bof",
      "Correct",
      "Bien",
      "Très bon",
      "Adoré"
    ],
    "cookedOnDismiss": "Je l'ai noté comme cuisiné."
  },
  "entry": {
    "dining": "Au resto",
    "diningLong": "Resto ou livraison",
    "leftovers": "Restes",
    "note": "Repas simple",
    "nothing": "Rien de prévu",
    "nothingShort": "Rien",
    "nothingThatDay": "Rien ce jour-là",
    "chooseRecipe": "Choisir une recette",
    "clearSlot": "Vider la case",
    "restaurantShort": "Resto",
    "currently": "ACTUELLEMENT",
    "noteFree": "Repas simple",
    "subLibrary": "La bibliothèque",
    "subEatingOut": "Je mange dehors",
    "subRecentMeal": "D'un repas récent",
    "subNoteHint": "Sandwich au thon, omelette…",
    "subNoPlan": "Aucun repas planifié",
    "replaceDish": "Remplacer ce plat",
    "addMeal": "Ajouter un repas",
    "view": "Voir",
    "ideasForYou": "IDÉES POUR VOUS",
    "ideaForYou_one": "{{count}} IDÉE POUR VOUS",
    "ideaForYou_other": "{{count}} IDÉES POUR VOUS",
    "noOtherRecipes": "Pas d'autres recettes dans votre bibliothèque. Ajoutez-en pour recevoir des idées.",
    "editMeal": "Modifier ce repas",
    "leftoverTitle": "Restes — {{title}}",
    "recentMeal": "repas récent",
    "editSlotCaption": "MODIFIER LA CASE",
    "addToSlotCaption": "AJOUTER À CETTE CASE",
    "leftoversHint": "Ce qui reste au frigo",
    "skipHint": "On saute ce repas"
  },
  "cooking": {
    "timer": "MINUTEUR",
    "theSteps": "LES ÉTAPES",
    "previous": "Précédent",
    "noSteps": "Aucune étape disponible pour cette recette.",
    "enjoy": "Bon appétit !",
    "likedRecipe": "Vous avez aimé cette recette ?",
    "skipForNow": "Passer pour l'instant",
    "startCooking": "Démarrer la cuisson",
    "cookingStart": "DÉBUT DE LA CUISSON",
    "timeline": "DÉROULEMENT",
    "atTable": "À table",
    "atTableAt": "À table à",
    "stepNumber": "ÉTAPE {{number}}",
    "nextStep": "Étape suivante",
    "ready": "C'est prêt !",
    "timerDone": "Terminé",
    "timerStart": "Démarrer",
    "timerPause": "Pause",
    "timelineStartPrep": "Commencer la préparation",
    "timelineStartCooking": "Commencer la cuisson",
    "timelineStart": "Commencer",
    "timelineReady": "Prêt à servir",
    "quit": "Quitter"
  },
  "classify": {
    "main course": "Repas",
    "dessert": "Dessert",
    "breakfast": "Déjeuner",
    "beverage": "Boisson",
    "sauce": "Sauce",
    "snack": "Collation",
    "appetizer": "Entrée",
    "salad": "Salade",
    "soup": "Soupe",
    "side dish": "Accompagnement"
  },
  "photoImport": {
    "readingRecipe": "Lecture de votre recette…",
    "addAnotherPage": "Ajouter une page",
    "couldNotRead": "Lecture difficile",
    "chooseAnother": "Choisir une autre",
    "saveToPaprika": "Enregistrer dans Du Chef",
    "pasteLufa": "Collez votre courriel de commande Lufa ici…",
    "parsingOrder": "Analyse de votre commande…",
    "unknownParseError": "Erreur d'analyse inconnue",
    "voiceHint": "Touchez le micro de votre clavier pour la dictée",
    "lufaTitle": "Importer une livraison Lufa",
    "lufaInstruction": "Collez ci-dessous le courriel de confirmation de votre commande Lufa",
    "parseOrder": "Lire la commande",
    "itemsSelected_one": "{{count}} article sélectionné",
    "itemsSelected_other": "{{count}} articles sélectionnés",
    "deliveryDate": "Livraison : {{date}}",
    "addItemsToPantry_one": "Ajouter {{count}} article au garde-manger",
    "addItemsToPantry_other": "Ajouter {{count}} articles au garde-manger",
    "frozen": "Surgelé",
    "blurry": "La photo était trop floue ou ne contenait pas de recette lisible. Essayez avec une photo plus nette.",
    "retakePhoto": "Reprendre la photo",
    "confidence": "Fiabilité",
    "incompleteWarning": "Certains champs sont peut-être incomplets — vérifiez avant d'enregistrer.",
    "titleLabel": "Titre",
    "prepMinutes": "Prép. {{minutes}} min",
    "cookMinutes": "Cuisson {{minutes}} min",
    "servings_one": "{{count}} portion",
    "servings_other": "{{count}} portions",
    "ingredientsCount": "Ingrédients ({{count}})",
    "instructionsCount": "Instructions ({{count}})",
    "editBeforeSaving": "Modifier avant d'enregistrer",
    "importRecipe": "Importer une recette",
    "reviewRecipe": "Vérifier la recette",
    "pageNumber": "Page {{number}}",
    "addMorePagesHint": "Ajoutez des pages si votre recette tient sur plusieurs photos.",
    "pagesReady": "{{count}} pages prêtes à numériser.",
    "scanRecipe": "Numériser la recette",
    "scanPages": "Numériser {{count}} pages",
    "preparingPhoto": "Préparation de la photo…",
    "analyzingPhoto": "Analyse en cours…",
    "sourceName": "Photo",
    "lufaReadFailed": "Je n'ai pas pu lire cette commande. Vérifiez que le texte du courriel est complet, puis réessayez."
  },
  "matchReason": {
    "taste": "Correspond à vos goûts",
    "novelty": "Nouvelle recette à essayer !"
  },
  "household": {
    "errAlreadyPaired": "Vous partagez déjà avec quelqu'un. Quittez d'abord ce foyer.",
    "rowSoloTitle": "Partager avec votre partenaire",
    "rowSoloSubtitle": "Planifiez, magasinez et cuisinez ensemble",
    "rowPendingTitle": "Invitation en attente",
    "rowPendingSubtitle": "Code {{code}} · expire dans {{hours}} h",
    "rowPendingSubtitleSoon": "Code {{code}} · expire bientôt",
    "rowPairedTitle": "Partagé avec {{name}}",
    "headerTitle": "Foyer",
    "soloHeadline": "Planifiez, magasinez et cuisinez ensemble.",
    "soloBody": "Invitez une personne. Tout ce qui suit devient partagé entre vous deux.",
    "sharesPlan": "Le menu de la semaine",
    "sharesGrocery": "La liste d'épicerie",
    "sharesRecipes": "Les recettes enregistrées et les notes",
    "sharesPantry": "Le garde-manger",
    "createInvitation": "Créer une invitation",
    "creating": "Création de votre invitation…",
    "pendingHeadline": "En attente de votre partenaire",
    "pendingBody": "Envoyez-lui ce code, ou le lien. Il ne fonctionne qu’une fois.",
    "codeLabel": "VOTRE CODE D'INVITATION",
    "expiresIn": "Expire dans {{hours}} heures",
    "expiresSoon": "Expire d'ici une heure",
    "shareLink": "Partager le lien",
    "copyCode": "Copier le code",
    "copied": "Copié",
    "cancelInvitation": "Annuler cette invitation",
    "cancelling": "Annulation…",
    "shareMessage": "Rejoignez mon foyer Du Chef — nous partagerons les recettes, le menu et la liste d'épicerie.\n\n{{link}}\n\nOu entrez le code : {{code}}",
    "pairedHeadline": "Votre foyer",
    "pairedBody": "Deux personnes. Tout ce qui suit est partagé.",
    "you": "Vous",
    "memberSince": "Membre depuis le {{date}}",
    "leaveHousehold": "Quitter ce foyer",
    "removePartner": "Retirer {{name}}",
    "leaveTitle": "Quitter ce foyer ?",
    "leaveBody": "Vous gardez chacun une copie complète. Rien n’est supprimé.",
    "removeTitle": "Retirer {{name}} ?",
    "removeBody": "Cette personne garde une copie complète. Rien n’est supprimé.",
    "keepsHead": "Vous gardez",
    "keepsHeadThem": "Cette personne garde",
    "keepRecipes": "Recettes enregistrées",
    "keepRatings": "Notes",
    "keepPantry": "Articles du garde-manger",
    "keepWeeks": "Semaines de menu",
    "leaveConfirm": "Quitter",
    "removeConfirm": "Retirer",
    "stay": "Rester",
    "leavingTitle": "Transfert en cours",
    "leavingBody": "Nous copions tout vers votre compte. Gardez l’application ouverte.",
    "leaving": "Départ en cours…",
    "removingTitle": "Transfert en cours",
    "removingBody": "Nous copions tout vers son compte. Gardez l’application ouverte.",
    "removing": "Retrait en cours…",
    "leftTitle": "Vous avez quitté le foyer.",
    "leftBody": "{{recipes}} recettes, {{ratings}} notes et {{pantry}} articles sont dans votre compte.",
    "removedTitle": "{{name}} a été retiré du foyer.",
    "removedBody": "Cette personne garde une copie complète. Le foyer est désormais le vôtre.",
    "leftUnverifiedTitle": "Vous avez quitté le foyer, mais rien ne s’est chargé ici.",
    "leftUnverifiedBody": "Vos données sont en sécurité. Rechargez pour les voir.",
    "reload": "Recharger",
    "errLeave": "Impossible de quitter le foyer. Veuillez réessayer.",
    "nameTitle": "Comment devrions-nous vous appeler ?",
    "nameBody": "Votre partenaire verra ce nom plutôt que votre adresse courriel.",
    "namePlaceholder": "Prénom",
    "nameSave": "Continuer",
    "nameSkip": "Plus tard",
    "errSignedOut": "Vous devez être connecté pour partager avec un partenaire.",
    "errGeneric": "Impossible de créer l'invitation. Veuillez réessayer.",
    "errMoveFailed": "Vos recettes et votre garde-manger n’ont pas pu être déplacés dans le foyer. Rien n’a changé. Veuillez réessayer.",
    "errNetwork": "Pas de connexion. Vérifiez votre réseau et réessayez.",
    "errSessionExpired": "Vous n’êtes plus connecté. Reconnectez-vous, puis réessayez.",
    "errSessionChanged": "Votre compte a changé dans un autre onglet. Rechargez la page et réessayez.",
    "errFull": "Votre foyer compte déjà deux membres.",
    "errNotInHousehold": "Vous ne faites plus partie de ce foyer. Rechargez la page.",
    "errRevoke": "Impossible d’annuler l’invitation. Veuillez réessayer.",
    "tryAgain": "Réessayer",
    "approval": {
      "agree": "Ça me va",
      "refuse": "Pas celle-là",
      "agreedBoth": "Vous êtes d'accord",
      "self": "vous",
      "cooks": "{{name}} cuisine",
      "cooksYou": "vous cuisinez",
      "claim": "Je m'en occupe",
      "propose": "Proposer",
      "proposedBy": "Proposé · {{name}}",
      "putOnMenu": "Mettre au menu",
      "noneOnMenu": "Aucune recette au menu",
      "toSettle": "{{count}} proposition à trancher",
      "toSettle_other": "{{count}} propositions à trancher"
    },
    "eaters": {
      "sectionTitle": "QUI MANGE ICI",
      "addSomeone": "Ajouter quelqu’un",
      "account": "compte",
      "accountsElsewhere": "Les comptes se modifient dans les réglages.",
      "selfLabel": "Vous",
      "firstName": "Prénom",
      "namePlaceholder": "Jules",
      "addTitle": "Ajouter quelqu’un",
      "add": "Ajouter",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "remove": "Retirer du foyer",
      "removeNote": "Ses avis passés sont conservés.",
      "empty": "Ajoutez les autres personnes qui mangent à la maison."
    },
    "verdict": {
      "title_one": "Vous étiez {{count}} à table",
      "title_other": "Vous étiez {{count}} à table",
      "question": "{{title}} — qui a aimé ?",
      "love": "Adoré",
      "ok": "Bof",
      "no": "Non",
      "later": "Plus tard",
      "addPeople": "Ajouter les autres",
      "soloHint": "Ajoutez les autres personnes à table pour recueillir leur avis.",
      "done": "Terminé",
      "sectionLabel": "QUI A AIMÉ ?",
      "whoLiked": "Qui a aimé ?",
      "overflow": "+{{count}}",
      "unanswered": "pas de réponse"
    }
  },
  "scanGate": {
    "title": "Créez un compte pour scanner",
    "body": "Pour lire la photo d'un frigo, d'un reçu ou d'une recette, Du Chef a besoin d'un compte : c'est là que votre garde-manger et vos recettes sont gardés. C'est gratuit, et votre menu vous suit.",
    "cta": "Créer un compte gratuit",
    "signIn": "J'ai déjà un compte",
    "later": "Plus tard",
    "lockedHint": "Avec un compte",
    "signedOut": "Vous n'êtes plus connecté. Reconnectez-vous pour scanner.",
    "signInAgain": "Se reconnecter"
  },
  "recipeMetadata": {
    "cuisine": "Cuisine",
    "dishType": "Type",
    "diet": "Régime",
    "accept": "Accepter",
    "choose": "Choisir",
    "suggesting": "Suggestions en cours…",
    "suggestFailed": "Les suggestions ont échoué. Réessayez.",
    "reviewFailed": "Impossible d'enregistrer les étiquettes. Réessayez.",
    "source": {
      "publisher": "selon la page",
      "rules": "règle",
      "model": "IA"
    },
    "cuisines": {
      "quebecois": "Québécoise",
      "french": "Française",
      "italian": "Italienne",
      "spanish": "Espagnole",
      "greek": "Grecque",
      "middle-eastern": "Moyen-Orient",
      "north-african": "Afrique du Nord",
      "indian": "Indienne",
      "chinese": "Chinoise",
      "japanese": "Japonaise",
      "korean": "Coréenne",
      "thai": "Thaïe",
      "vietnamese": "Vietnamienne",
      "mexican": "Mexicaine",
      "latin-american": "Amérique latine",
      "caribbean": "Caraïbes",
      "american": "Américaine",
      "eastern-european": "Europe de l'Est",
      "everyday": "De tous les jours"
    },
    "diets": {
      "meat": "Viande",
      "fish": "Poisson",
      "veg": "Végétarien"
    },
    "checks": {
      "image_mismatch": "La photo semble montrer un autre plat",
      "image_missing": "Aucune photo",
      "unused_ingredients": "Utilisé dans aucune étape : {{items}}",
      "missing_ingredients": "Les étapes demandent : {{items}}",
      "prep_exceeds_total": "La préparation dépasse le temps total",
      "parts_exceed_total": "Préparation + cuisson dépassent le temps total",
      "total_default": "Le temps total ressemble à un 30 min par défaut",
      "total_missing": "Aucun temps total",
      "timeline_disputed": "Le temps estimé ne colle pas avec la page",
      "timeline_person": "Temps entré à la main : {{ready}}",
      "timelineDisputedEstimate": "Estimation : {{handsOn}} de préparation, prêt en {{ready}}"
    },
    "time": "Temps",
    "timeTotal": "{{total}} min",
    "timeParts": "{{prep}} + {{cook}} min",
    "timePartsTotal": "{{prep}} + {{cook}} · {{total}} min",
    "timePrepTotal": "{{prep}} · {{total}} min",
    "timeHandsOn": "Préparation (vous, min)",
    "timeCook": "Cuisson (min)",
    "timeReady": "Prêt en (min)",
    "timeTotalHint": "vide = Préparation + Cuisson",
    "timeSave": "Enregistrer le temps",
    "timeInvalid": "Entrez des minutes entières. « Prêt en » ne peut pas être plus court que la préparation ou la cuisson.",
    "timeFromPage": "Selon la page : {{value}}",
    "timeAiGuess": "Proposition de l'IA : {{value}}"
  },
  "errorBoundary": {
    "message": "L'application a rencontré un problème inattendu. Vous pouvez réessayer ou revenir à l'accueil.",
    "retry": "Réessayer",
    "goHome": "Retour à l'accueil"
  },
  "syncStatus": {
    "updating": "Mise à jour…",
    "upToDate": "À jour",
    "updatedAgo": "Mis à jour {{ago}}",
    "justNow": "à l'instant",
    "minutesAgo": "il y a {{count}} min",
    "hoursAgo": "il y a {{count}} h",
    "daysAgo_one": "il y a {{count}} jour",
    "daysAgo_other": "il y a {{count}} jours"
  },
  "skipFeedback": {
    "titleRemove": "Pourquoi l'enlever ?",
    "titleReplace": "Pourquoi le remplacer ?",
    "placeholderRemove": "ex. « Trop lourd pour un soir de semaine »",
    "placeholderReplace": "ex. « Quelque chose de plus rapide »",
    "skip": "Passer sans commentaire",
    "submit": "Envoyer",
    "typeSomething": "Écrivez quelque chose ci-dessus"
  },
  "ingredientReview": {
    "checkHave": "Cochez les ingrédients que vous avez déjà",
    "uncheckedToList": "Les articles non cochés seront ajoutés à votre liste d'épicerie",
    "foundInInventory_one": "{{count}} article trouvé dans votre inventaire",
    "foundInInventory_other": "{{count}} articles trouvés dans votre inventaire",
    "confirmMatches_one": "Confirmer {{count}} correspondance",
    "confirmMatches_other": "Confirmer {{count}} correspondances",
    "inInventory": "En inventaire",
    "plusList": "+ liste",
    "haveCount": "{{count}} en main",
    "needCount": "{{count}} à acheter",
    "markReviewed": "Marquer comme vérifié"
  },
  "pantryMatch": {
    "all": "Les {{count}} ingrédients sont dans votre garde-manger !",
    "none": "Aucun des {{count}} ingrédients n'est dans votre garde-manger",
    "covers": "Votre garde-manger couvre {{matched}} des {{total}} ingrédients",
    "more": "+{{count}} autres",
    "needToBuy": "À acheter : encore {{count}}"
  },
  "smartInventory": {
    "title": "Inventaire intelligent",
    "curating": "Mise à jour de\nvotre inventaire…",
    "devMode": "MODE DEV",
    "hintFridge": "Cadrez les aliments pour un meilleur résultat",
    "hintReceipt": "Centrez le reçu dans le cadre",
    "noImage": "Aucune image fournie",
    "percentComplete": "{{percent}} % TERMINÉ",
    "oldReceipt_one": "Reçu du {{date}} (il y a {{count}} jour) — les dates de péremption estimées peuvent être imprécises",
    "oldReceipt_other": "Reçu du {{date}} (il y a {{count}} jours) — les dates de péremption estimées peuvent être imprécises",
    "scanningPantry": "ANALYSE DU GARDE-MANGER",
    "scanningReceipt": "ANALYSE DU REÇU"
  }
}
